(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ali/dinamic"), require("react-dom"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["@ali/dinamic", "react-dom", "react"], factory);
	else if(typeof exports === 'object')
		exports["DinamicViews"] = factory(require("@ali/dinamic"), require("react-dom"), require("react"));
	else
		root["DinamicViews"] = factory(root["Dinamic"], root["ReactDOM"], root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? module.exports = factory() :
  undefined;
}(this, (function () { 'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  var doc = window.document;
  var docEl = doc.documentElement; // 类数组对象转换为数组

  var toArray = function toArray(likeArray) {
    return Array.prototype.slice.call(likeArray);
  }; // 手势收集


  var gestures = {}; // 连击记录，doubletap 取有效次数用

  var lastTap = null;
  var LONG_TAP_THRESHOLD = 500;
  var DOUBLE_TAP_THRESHOLD = 300;
  var PAN_DIS_THRESHOLD = 10;
  var SUPPORT_TOUCH = 'ontouchstart' in docEl;
  var EVENT_TYPE_MAPPING = {
    'tap': 'click'
  };
  var EVENT_PREFIX = 'dx_'; // 方向判断

  var getDirection = function getDirection(moveX, moveY) {
    if (Math.abs(moveX) > Math.abs(moveY)) {
      // 横向大于纵向
      return moveX < 0 ? 'left' : 'right';
    } else {
      // 纵向大于横向
      return moveY < 0 ? 'up' : 'down';
    }
  };

  function bindTouchStartListenerOnce() {
    docEl.addEventListener('touchstart', touchstartHandler, false);
  }
  /**
   * changed​Touches对象用于处理多指控制的场景，且在不同的事件中有对应的处理逻辑
   * 对于 touchstart 事件, 这个 TouchList 对象列出在此次事件中新增加的触点。
   * 对于 touchmove 事件，列出和上一次事件相比较，发生了变化的触点。
   * 对于touchend事件，changedTouches 是已经从触摸面的离开的触点的集合（也就是说，手指已经离开了屏幕/触摸面）
   */

  /**
   * 找到两个结点共同的最小根结点
   * 如果跟结点不存在，则返回null
   *
   * @param  {Element} el1 第一个结点
   * @param  {Element} el2 第二个结点
   * @return {Element}     根结点
   */


  function getCommonAncestor(el1, el2) {
    var el = el1;

    while (el) {
      if (el.contains(el2) || el === el2) {
        return el;
      }

      el = el.parentNode;
    }

    return null;
  }
  /**
   * 触发一个事件
   *
   * @param  {Element} $el 目标结点
   * @param  {string}  eventName    事件类型
   * @param  {object}  extra   对事件对象的扩展
   */


  function fireEvent($el, eventName, extra) {
    var event = doc.createEvent('HTMLEvents');
    event.initEvent(eventName, true, true);

    if (_typeof(extra) === 'object') {
      for (var key in extra) {
        event[key] = extra[key];
      }
    }

    $el.dispatchEvent(event);
  }
  /**
   * 计算变换效果
   * 假设坐标系上有4个点ABCD
   * > 旋转：从AB旋转到CD的角度
   * > 缩放：从AB长度变换到CD长度的比例
   * > 位移：从A点位移到C点的横纵位移
   *
   * @param  {number} x1 上述第1个点的横坐标
   * @param  {number} y1 上述第1个点的纵坐标
   * @param  {number} x2 上述第2个点的横坐标
   * @param  {number} y2 上述第2个点的纵坐标
   * @param  {number} x3 上述第3个点的横坐标
   * @param  {number} y3 上述第3个点的纵坐标
   * @param  {number} x4 上述第4个点的横坐标
   * @param  {number} y4 上述第4个点的纵坐标
   * @return {object}    变换效果，形如{rotate, scale, translate[2], matrix[3][3]}
   */


  function calc(x1, y1, x2, y2, x3, y3, x4, y4) {
    var rotate = Math.atan2(y4 - y3, x4 - x3) - Math.atan2(y2 - y1, x2 - x1);
    var scale = Math.sqrt((Math.pow(y4 - y3, 2) + Math.pow(x4 - x3, 2)) / (Math.pow(y2 - y1, 2) + Math.pow(x2 - x1, 2)));
    var translate = [x3 - scale * x1 * Math.cos(rotate) + scale * y1 * Math.sin(rotate), y3 - scale * y1 * Math.cos(rotate) - scale * x1 * Math.sin(rotate)];
    return {
      rotate: rotate,
      scale: scale,
      translate: translate,
      matrix: [[scale * Math.cos(rotate), -scale * Math.sin(rotate), translate[0]], [scale * Math.sin(rotate), scale * Math.cos(rotate), translate[1]], [0, 0, 1]]
    };
  }
  /**
   * 捕获touchstart事件，将每一个新增的触点添加到gestrues
   * 如果之前尚无被记录的触点，则绑定touchmove, touchend, touchcancel事件
   *
   * 新增触点默认处于tapping状态
   * 500毫秒之后如果还处于tapping状态，则触发longTap手势
   * 如果触点数为2，则触发dualtouchstart手势，该手势的目标结点为两个触点共同的最小根结点
   *
   * @event
   * @param  {event} event
   */


  function touchstartHandler(event) {
    if (Object.keys(gestures).length === 0) {
      docEl.addEventListener('touchmove', touchmoveHandler, false);
      docEl.addEventListener('touchend', touchendHandler, false);
      docEl.addEventListener('touchcancel', touchcancelHandler, false);
    }

    var gesture;
    var touch;
    var touchRecord;
    var elements;
    /**
     * 创建长按事件的处理函数
     * @param {domEl} element dom节点
     * @param {event} touch 触摸事件对象
     */

    function createLongTapHandler(element, touch) {
      return function () {
        if (gesture.status === 'tapping') {
          gesture.status = 'longTapping';
          fireEvent(element, EVENT_PREFIX + 'longtap', {
            touch: touch,
            touches: event.touches,
            changedTouches: event.changedTouches,
            touchEvent: event
          });
        } // touchstart开始后，如果在500ms内没有发生了touchend则会触发长按事件，在事件过程中清除延时器。
        // 否则会在touchend的处理过程中清除延时器。


        clearTimeout(gesture.longTapHandler);
        gesture.longTapHandler = null;
      };
    } // 1. 遍历触点 保存在gestures中


    for (var i = 0; i < event.changedTouches.length; i++) {
      touch = event.changedTouches[i];
      touchRecord = {};

      for (var p in touch) {
        touchRecord[p] = touch[p];
      }

      gesture = {
        startTouch: touchRecord,
        startTime: Date.now(),
        status: 'tapping',
        element: event.srcElement || event.target,
        // 3. 触发长按
        longTapHandler: setTimeout(createLongTapHandler(event.srcElement || event.target, event.changedTouches[i]), LONG_TAP_THRESHOLD)
      };
      gestures[touch.identifier] = gesture;
    } // 2. 处理双指情况


    if (Object.keys(gestures).length === 2) {
      elements = [];

      for (var key in gestures) {
        elements.push(gestures[key].element);
      } // 对于双指的情况肯定是发生在一个元素上的，所以寻找最小根节点触发


      fireEvent(getCommonAncestor(elements[0], elements[1]), EVENT_PREFIX + 'dualtouchstart', {
        touches: toArray(event.touches),
        touchEvent: event
      });
    }
  }
  /**
   * 捕获touchmove事件，处理pan和dual的相关手势
   *
   * 1. 遍历每个触点：
   * 如果触点之前处于tapping状态，且位移超过10像素，则认定为进入panning状态
   * 先触发panstart手势，然后根据移动的方向选择性触发horizontalpanstart或verticalpanstart手势
   * 如果触点之前处于panning状态，则根据pan的初始方向触发horizontalpan或verticalpan手势
   *
   * 2. 如果当前触点数为2，则计算出几何变换的各项参数，触发dualtouch手势
   *
   * @event
   * @param  {event} event
   */


  function touchmoveHandler(event) {
    // 遍历每个触点：
    // 1. 如果触点之前处于tapping状态，且位移超过10像素，则认定为进入panning状态
    // 先触发panstart手势，然后根据移动的方向选择性触发horizontalpanstart或verticalpanstart手势
    // 2. 如果触点之前处于panning状态，则根据pan的初始方向触发horizontalpan或verticalpan手势
    for (var i = 0; i < event.changedTouches.length; i++) {
      var touch = event.changedTouches[i];
      var gesture = gestures[touch.identifier];
      if (!gesture) return; // init

      if (!gesture.lastTouch) {
        gesture.lastTouch = gesture.startTouch;
      }

      if (!gesture.lastTime) {
        gesture.lastTime = gesture.startTime;
      }

      if (!gesture.velocityX) {
        gesture.velocityX = 0;
      }

      if (!gesture.velocityY) {
        gesture.velocityY = 0;
      }

      if (!gesture.duration) {
        gesture.duration = 0;
      }

      var time = Date.now() - gesture.lastTime;
      var vx = (touch.clientX - gesture.lastTouch.clientX) / time;
      var vy = (touch.clientY - gesture.lastTouch.clientY) / time;
      var RECORD_DURATION = 70;

      if (time > RECORD_DURATION) {
        time = RECORD_DURATION;
      }

      if (gesture.duration + time > RECORD_DURATION) {
        gesture.duration = RECORD_DURATION - time;
      }

      gesture.velocityX = (gesture.velocityX * gesture.duration + vx * time) / (gesture.duration + time);
      gesture.velocityY = (gesture.velocityY * gesture.duration + vy * time) / (gesture.duration + time);
      gesture.duration += time;
      gesture.lastTouch = {};

      for (var p in touch) {
        gesture.lastTouch[p] = touch[p];
      }

      gesture.lastTime = Date.now(); // 位移量比较纵横滑动

      var displacementX = touch.clientX - gesture.startTouch.clientX;
      var displacementY = touch.clientY - gesture.startTouch.clientY;
      var direction = getDirection(displacementX, displacementY); // 勾股定理

      var distance = Math.sqrt(Math.pow(displacementX, 2) + Math.pow(displacementY, 2));

      if ((gesture.status === 'tapping' || gesture.status === 'longTapping') && distance > PAN_DIS_THRESHOLD) {
        gesture.status = 'panning';
        fireEvent(gesture.element, EVENT_PREFIX + 'panbegin', {
          touch: touch,
          touches: event.touches,
          changedTouches: event.changedTouches,
          touchEvent: event,
          direction: direction
        });
      }

      if (gesture.status === 'panning') {
        gesture.panTime = Date.now();
        fireEvent(gesture.element, EVENT_PREFIX + 'panmove', {
          displacementX: displacementX,
          displacementY: displacementY,
          touch: touch,
          direction: direction,
          touches: event.touches,
          changedTouches: event.changedTouches,
          touchEvent: event
        });
      }
    } // 如果当前触点数为2，则计算出几何变换的各项参数，触发dualtouch手势


    if (Object.keys(gestures).length === 2) {
      var position = [];
      var current = [];
      var elements = [];
      var transform;

      for (var _i = 0; _i < event.touches.length; _i++) {
        var _touch = event.touches[_i];
        var _gesture = gestures[_touch.identifier];
        position.push([_gesture.startTouch.clientX, _gesture.startTouch.clientY]);
        current.push([_touch.clientX, _touch.clientY]);
      }

      for (var _p in gestures) {
        elements.push(gestures[_p].element);
      }

      transform = calc(position[0][0], position[0][1], position[1][0], position[1][1], current[0][0], current[0][1], current[1][0], current[1][1]); // TODO: 双指的旋转缩放等操作需要在这里进行更多的判断处理,暂时先不写了

      fireEvent(getCommonAncestor(elements[0], elements[1]), EVENT_PREFIX + 'dualtouch', {
        transform: transform,
        touches: event.touches,
        touchEvent: event
      });
    }
  }
  /**
   * 捕获touchend事件
   *
   * 1. 如果当前触点数为2，则触发dualtouchend手势
   *
   * 2. 遍历每个触点：
   * > 如果处于tapping状态，则触发tap手势
   * 如果之前300毫秒出现过tap手势，则升级为doubletap手势
   * > 如果处于panning状态，则根据滑出的速度，触发panend/flick手势
   *
   * 3. 解绑定所有相关事件
   *
   * @event
   * @param  {event} event
   */


  function touchendHandler(event) {
    if (Object.keys(gestures).length === 2) {
      var elements = [];

      for (var p in gestures) {
        elements.push(gestures[p].element);
      }

      fireEvent(getCommonAncestor(elements[0], elements[1]), EVENT_PREFIX + 'dualtouchend', {
        touches: toArray(event.touches),
        touchEvent: event
      });
    }

    for (var i = 0; i < event.changedTouches.length; i++) {
      var touch = event.changedTouches[i];
      var id = touch.identifier;
      var gesture = gestures[id];

      if (!gesture) {
        continue;
      }

      if (gesture.longTapHandler) {
        clearTimeout(gesture.longTapHandler);
        gesture.longTapHandler = null;
      }

      if (gesture.status === 'tapping') {
        gesture.timestamp = Date.now();
        fireEvent(gesture.element, EVENT_PREFIX + 'tap', {
          touch: touch,
          touchEvent: event
        });

        if (lastTap && gesture.timestamp - lastTap.timestamp < DOUBLE_TAP_THRESHOLD) {
          fireEvent(gesture.element, EVENT_PREFIX + 'doubletap', {
            touch: touch,
            touchEvent: event
          });
        }

        lastTap = gesture;
      }

      if (gesture.status === 'panning') {
        var now = Date.now();
        var duration = now - gesture.startTime;
        var displacementX = touch.clientX - gesture.startTouch.clientX;
        var displacementY = touch.clientY - gesture.startTouch.clientY;
        var direction = getDirection(displacementX, displacementY); // 滑动加速度

        var velocity = Math.sqrt(gesture.velocityY * gesture.velocityY + gesture.velocityX * gesture.velocityX); // 快速滑动

        var isflick = velocity > 0.5 && now - gesture.lastTime < 100;
        var extra = {
          duration: duration,
          isflick: isflick,
          velocityX: gesture.velocityX,
          velocityY: gesture.velocityY,
          displacementX: displacementX,
          displacementY: displacementY,
          touch: touch,
          direction: direction,
          touches: event.touches,
          changedTouches: event.changedTouches,
          touchEvent: event
        };
        fireEvent(gesture.element, EVENT_PREFIX + 'panend', extra);
        if (isflick) fireEvent(gesture.element, EVENT_PREFIX + 'swipe', extra);
      }

      delete gestures[id];
    }

    if (Object.keys(gestures).length === 0) {
      docEl.removeEventListener('touchmove', touchmoveHandler, false);
      docEl.removeEventListener('touchend', touchendHandler, false);
      docEl.removeEventListener('touchcancel', touchcancelHandler, false);
    }
  }
  /**
   * 捕获touchcancel事件
   *
   * 1. 如果当前触点数为2，则触发dualtouchend手势
   *
   * 2. 遍历每个触点：
   *  如果处于panning状态，则触发panend手势
   *
   * 3. 解绑定所有相关事件
   *
   * @event
   * @param  {event} event
   */


  function touchcancelHandler(event) {
    if (Object.keys(gestures).length === 2) {
      var elements = [];

      for (var p in gestures) {
        elements.push(gestures[p].element);
      }

      fireEvent(getCommonAncestor(elements[0], elements[1]), EVENT_PREFIX + 'dualtouchend', {
        touches: toArray(event.touches),
        touchEvent: event
      });
    }

    for (var i = 0; i < event.changedTouches.length; i++) {
      var touch = event.changedTouches[i];
      var id = touch.identifier;
      var gesture = gestures[id];

      if (!gesture) {
        continue;
      }

      if (gesture.longTapHandler) {
        clearTimeout(gesture.longTapHandler);
        gesture.longTapHandler = null;
      }

      if (gesture.status === 'panning') {
        fireEvent(gesture.element, EVENT_PREFIX + 'panend', {
          touch: touch,
          touches: event.touches,
          changedTouches: event.changedTouches,
          touchEvent: event
        });
      }

      delete gestures[id];
    }

    if (Object.keys(gestures).length === 0) {
      docEl.removeEventListener('touchmove', touchmoveHandler, false);
      docEl.removeEventListener('touchend', touchendHandler, false);
      docEl.removeEventListener('touchcancel', touchcancelHandler, false);
    }
  }
  /**
   * 事件工厂函数，on方法是为了保持和原有事件机制相同的api
   */


  var EventFactory =
  /*#__PURE__*/
  function () {
    function EventFactory(el, options, pcMode) {
      var _this = this;

      _classCallCheck(this, EventFactory);

      this._pc_mode = pcMode; // pc 模式只支持 click 事件，不要绑 touch 事件，一些 windows 触摸屏设备有 js error

      if (!this._pc_mode) {
        // touch 事件只绑定一次
        bindTouchStartListenerOnce();
      }

      this.el = el;

      var _loop = function _loop(eventType) {
        var eType = _this.processEventType(eventType);

        _this.el.addEventListener(eType, function (e) {
          e.stopPropagation();
          options[eventType](e);
        });
      };

      for (var eventType in options) {
        _loop(eventType);
      }
    }

    _createClass(EventFactory, [{
      key: "on",
      value: function on(eventType, handler) {
        var eType = this.processEventType(eventType);
        this.el.addEventListener(eType, function (e) {
          e.stopPropagation();
          handler(e);
        });
      } // 不支持 touch 的设备，tap 替换为 click

    }, {
      key: "processEventType",
      value: function processEventType() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var eType = type.toLowerCase();
        var prefix = EVENT_PREFIX;

        if ((!SUPPORT_TOUCH || this._pc_mode) && EVENT_TYPE_MAPPING[eType]) {
          eType = EVENT_TYPE_MAPPING[eType];
          prefix = '';
        }

        eType = prefix + eType;
        return eType;
      }
    }]);

    return EventFactory;
  }();

  return EventFactory;

})));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(12);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = backgroundClip;

// https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip#Browser_compatibility
function backgroundClip(property, value) {
  if (typeof value === 'string' && value === 'text') {
    return ['-webkit-text', 'text'];
  }
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines',
  flexGrow: 'WebkitBoxFlex'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(1);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return value.replace(values, function (grad) {
        return prefix + grad;
      });
    });
  }
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = logical;
var alternativeProps = {
  marginBlockStart: ['WebkitMarginBefore'],
  marginBlockEnd: ['WebkitMarginAfter'],
  marginInlineStart: ['WebkitMarginStart', 'MozMarginStart'],
  marginInlineEnd: ['WebkitMarginEnd', 'MozMarginEnd'],
  paddingBlockStart: ['WebkitPaddingBefore'],
  paddingBlockEnd: ['WebkitPaddingAfter'],
  paddingInlineStart: ['WebkitPaddingStart', 'MozPaddingStart'],
  paddingInlineEnd: ['WebkitPaddingEnd', 'MozPaddingEnd'],
  borderBlockStart: ['WebkitBorderBefore'],
  borderBlockStartColor: ['WebkitBorderBeforeColor'],
  borderBlockStartStyle: ['WebkitBorderBeforeStyle'],
  borderBlockStartWidth: ['WebkitBorderBeforeWidth'],
  borderBlockEnd: ['WebkitBorderAfter'],
  borderBlockEndColor: ['WebkitBorderAfterColor'],
  borderBlockEndStyle: ['WebkitBorderAfterStyle'],
  borderBlockEndWidth: ['WebkitBorderAfterWidth'],
  borderInlineStart: ['WebkitBorderStart', 'MozBorderStart'],
  borderInlineStartColor: ['WebkitBorderStartColor', 'MozBorderStartColor'],
  borderInlineStartStyle: ['WebkitBorderStartStyle', 'MozBorderStartStyle'],
  borderInlineStartWidth: ['WebkitBorderStartWidth', 'MozBorderStartWidth'],
  borderInlineEnd: ['WebkitBorderEnd', 'MozBorderEnd'],
  borderInlineEndColor: ['WebkitBorderEndColor', 'MozBorderEndColor'],
  borderInlineEndStyle: ['WebkitBorderEndStyle', 'MozBorderEndStyle'],
  borderInlineEndWidth: ['WebkitBorderEndWidth', 'MozBorderEndWidth']
};

function logical(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
    var alternativePropList = alternativeProps[property];
    for (var i = 0, len = alternativePropList.length; i < len; ++i) {
      style[alternativePropList[i]] = value;
    }
  }
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./src/verdorDetect.js
var elm = document.createElement('div');

elm.style.display = '-webkit-box';
elm.style.display = '-moz-box';
elm.style.display = '-webkit-flex';
elm.style.display = 'flex';
var flex = elm.style.display;

function chooseCssValue() {
  var attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var val = values[values.length - 1] || '';

  switch (attr) {
    case 'display':
      if (values.indexOf(flex) > -1) {
        val = flex;
      }
      break;
    default:
      break;
  }

  return val;
}
// EXTERNAL MODULE: external {"amd":"@ali/dinamic","commonjs":"@ali/dinamic","commonjs2":"@ali/dinamic","root":"Dinamic"}
var dinamic_root_Dinamic_ = __webpack_require__(0);
var dinamic_root_Dinamic_default = /*#__PURE__*/__webpack_require__.n(dinamic_root_Dinamic_);

// EXTERNAL MODULE: external {"amd":"react-dom","commonjs":"react-dom","commonjs2":"react-dom","root":"ReactDOM"}
var external_amd_react_dom_commonjs_react_dom_commonjs2_react_dom_root_ReactDOM_ = __webpack_require__(2);
var external_amd_react_dom_commonjs_react_dom_commonjs2_react_dom_root_ReactDOM_default = /*#__PURE__*/__webpack_require__.n(external_amd_react_dom_commonjs_react_dom_commonjs2_react_dom_root_ReactDOM_);

// EXTERNAL MODULE: ./node_modules/_@ali_dinamic-gesture@1.2.0@@ali/dinamic-gesture/dist/index.js
var dist = __webpack_require__(4);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./src/utils/index.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




var supportPerformanceAPI = (typeof performance === 'undefined' ? 'undefined' : _typeof(performance)) === 'object' && performance.now;

function isFunction(func) {
  return func && typeof func === 'function';
}

var deepGet = dinamic_root_Dinamic_["utils"].deepGet;

var isString = dinamic_root_Dinamic_["utils"].isString;

var isObject = function isObject(obj) {
  return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
};

var isEqual = dinamic_root_Dinamic_["utils"].isEqual;

var numTrunc = dinamic_root_Dinamic_["utils"].numTrunc;

var toLikeBoolean = function toLikeBoolean(b) {
  if (b === 'false' || b === false || b === '0' || !b) {
    return false;
  }

  return true;
};

/**
 * 绑定手势事件，会自动阻止touch冒泡
 * @param {HTMLElement} $el - 原生dom节点
 * @param {Object} options  - 需要绑定的事件回调 eg. { tap: () => {...} }
 */
var utils_bindGestureEvent = function bindGestureEvent($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var forcePcMode = Object(dinamic_root_Dinamic_["getGlobalConfig"])('forcePcMode');

  return new dist_default.a($el, options, forcePcMode);
};

/**
 * 执行高性能帧动画任务
 */
var runframeTask = function runframeTask(callback) {
  var taskQueue = [];

  var timeoutTaskId = void 0;
  return function (task) {
    taskQueue.push(task);

    if (timeoutTaskId) {
      window.clearTimeout(timeoutTaskId);
    }

    timeoutTaskId = setTimeout(function () {
      (function runPerFrame() {
        requestAnimationFrame(function (startTimestamp) {
          while (taskQueue.length > 0) {
            taskQueue.shift()();

            // 计算耗时
            var curTimestamp = supportPerformanceAPI ? performance.now() : startTimestamp;

            // 大于一帧时间之后，挪到下一帧执行（此处会留一些buffer）
            if (curTimestamp - startTimestamp >= 15) {
              break;
            }
          };

          // loop next frame
          if (taskQueue.length > 0) {
            runPerFrame();
          } else {
            callback();
          }
        });
      })();
    }, 0);
  };
};

/*------------------------------------------------------------*/

var isElementInvisable = function isElementInvisable($el) {
  return $el.offsetParent === null && $el.offsetHeight === 0;
};

/**
 * @param {String} propValue (leftTop)
 * @returns {Object} {left, top}
 */
var parseGravity = function parseGravity() {
  var propValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'leftTop';

  var upperIndex = propValue.search(/[A-Z]/);

  var x = void 0,
      y = void 0;
  if (upperIndex !== -1) {
    x = propValue.slice(0, upperIndex);
    y = propValue.slice(upperIndex).toLowerCase();
  } else {
    x = y = propValue;
  }

  return { x: x, y: y };
};
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/utils/capitalizeString.js
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/utils/prefixProperty.js



function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var newStyle = {};
    var requiredPrefixes = prefixProperties[property];
    var capitalizedProperty = capitalizeString(property);
    var keys = Object.keys(style);
    for (var i = 0; i < keys.length; i++) {
      var styleProperty = keys[i];
      if (styleProperty === property) {
        for (var j = 0; j < requiredPrefixes.length; j++) {
          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
        }
      }
      newStyle[styleProperty] = style[styleProperty];
    }
    return newStyle;
  }
  return style;
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/utils/prefixValue.js
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/utils/addNewValuesOnly.js
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/utils/isObject.js
function isObject_isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/createPrefixer.js






function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  return function prefix(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if (isObject_isObject(value)) {
        style[property] = prefix(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = prefixValue(plugins, property, value[i], style, prefixMap);
          addNewValuesOnly(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = prefixValue(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        style = prefixProperty(prefixMap, property, style);
      }
    }

    return style;
  };
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/data.js

var w = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];

/* harmony default export */ var es_data = ({
  plugins: [],
  prefixMap: { "appearance": wm, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "userSelect": wmms, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "clipPath": w, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "filter": w, "hyphens": wms, "flowInto": wms, "flowFrom": wms, "breakBefore": wms, "breakAfter": wms, "breakInside": wms, "regionFragment": wms, "writingMode": wms, "textOrientation": w, "tabSize": m, "fontFeatureSettings": w, "columnCount": w, "columnFill": w, "columnGap": w, "columnRule": w, "columnRuleColor": w, "columnRuleStyle": w, "columnRuleWidth": w, "columns": w, "columnSpan": w, "columnWidth": w, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "textSizeAdjust": wms }
});
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/plugins/backgroundClip.js

// https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip#Browser_compatibility
function backgroundClip(property, value) {
  if (typeof value === 'string' && value === 'text') {
    return ['-webkit-text', 'text'];
  }
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/plugins/cursor.js
var cursor_prefixes = ['-webkit-', '-moz-', ''];

var cursor_values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && cursor_values.hasOwnProperty(value)) {
    return cursor_prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
// EXTERNAL MODULE: ./node_modules/_css-in-js-utils@2.0.1@css-in-js-utils/lib/isPrefixedValue.js
var isPrefixedValue = __webpack_require__(1);
var isPrefixedValue_default = /*#__PURE__*/__webpack_require__.n(isPrefixedValue);

// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/plugins/crossFade.js


// http://caniuse.com/#search=cross-fade
var crossFade_prefixes = ['-webkit-', ''];

function crossFade(property, value) {
  if (typeof value === 'string' && !isPrefixedValue_default()(value) && value.indexOf('cross-fade(') > -1) {
    return crossFade_prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/plugins/filter.js


// http://caniuse.com/#feat=css-filter-function
var filter_prefixes = ['-webkit-', ''];

function filter_filter(property, value) {
  if (typeof value === 'string' && !isPrefixedValue_default()(value) && value.indexOf('filter(') > -1) {
    return filter_prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/plugins/flex.js
var flex_values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex_flex(property, value) {
  if (property === 'display' && flex_values.hasOwnProperty(value)) {
    return flex_values[value];
  }
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/plugins/flexboxOld.js
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines',
  flexGrow: 'WebkitBoxFlex'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/plugins/gradient.js


var gradient_prefixes = ['-webkit-', '-moz-', ''];
var gradient_values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;

function gradient(property, value) {
  if (typeof value === 'string' && !isPrefixedValue_default()(value) && gradient_values.test(value)) {
    return gradient_prefixes.map(function (prefix) {
      return value.replace(gradient_values, function (grad) {
        return prefix + grad;
      });
    });
  }
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/plugins/grid.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function isSimplePositionValue(value) {
  return typeof value === 'number' && !isNaN(value);
}

function isComplexSpanValue(value) {
  return typeof value === 'string' && value.includes('/');
}

var alignmentValues = ['center', 'end', 'start', 'stretch'];

var displayValues = {
  'inline-grid': ['-ms-inline-grid', 'inline-grid'],
  grid: ['-ms-grid', 'grid']
};

var propertyConverters = {
  alignSelf: function alignSelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridRowAlign = value;
    }
  },

  gridColumn: function gridColumn(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    } else if (isComplexSpanValue(value)) {
      var _value$split = value.split('/'),
          _value$split2 = _slicedToArray(_value$split, 2),
          start = _value$split2[0],
          end = _value$split2[1];

      propertyConverters.gridColumnStart(+start, style);

      var _end$split = end.split(/ ?span /),
          _end$split2 = _slicedToArray(_end$split, 2),
          maybeSpan = _end$split2[0],
          maybeNumber = _end$split2[1];

      if (maybeSpan === '') {
        propertyConverters.gridColumnEnd(+start + +maybeNumber, style);
      } else {
        propertyConverters.gridColumnEnd(+end, style);
      }
    } else {
      propertyConverters.gridColumnStart(value, style);
    }
  },

  gridColumnEnd: function gridColumnEnd(value, style) {
    var msGridColumn = style.msGridColumn;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridColumn)) {
      style.msGridColumnSpan = value - msGridColumn;
    }
  },

  gridColumnStart: function gridColumnStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    }
  },

  gridRow: function gridRow(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    } else if (isComplexSpanValue(value)) {
      var _value$split3 = value.split('/'),
          _value$split4 = _slicedToArray(_value$split3, 2),
          start = _value$split4[0],
          end = _value$split4[1];

      propertyConverters.gridRowStart(+start, style);

      var _end$split3 = end.split(/ ?span /),
          _end$split4 = _slicedToArray(_end$split3, 2),
          maybeSpan = _end$split4[0],
          maybeNumber = _end$split4[1];

      if (maybeSpan === '') {
        propertyConverters.gridRowEnd(+start + +maybeNumber, style);
      } else {
        propertyConverters.gridRowEnd(+end, style);
      }
    } else {
      propertyConverters.gridRowStart(value, style);
    }
  },

  gridRowEnd: function gridRowEnd(value, style) {
    var msGridRow = style.msGridRow;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridRow)) {
      style.msGridRowSpan = value - msGridRow;
    }
  },

  gridRowStart: function gridRowStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    }
  },

  gridTemplateColumns: function gridTemplateColumns(value, style) {
    style.msGridColumns = value;
  },

  gridTemplateRows: function gridTemplateRows(value, style) {
    style.msGridRows = value;
  },

  justifySelf: function justifySelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridColumnAlign = value;
    }
  }
};

function grid(property, value, style) {
  if (property === 'display' && value in displayValues) {
    return displayValues[value];
  }

  if (property in propertyConverters) {
    var propertyConverter = propertyConverters[property];
    propertyConverter(value, style);
  }
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/plugins/imageSet.js


// http://caniuse.com/#feat=css-image-set
var imageSet_prefixes = ['-webkit-', ''];

function imageSet(property, value) {
  if (typeof value === 'string' && !isPrefixedValue_default()(value) && value.indexOf('image-set(') > -1) {
    return imageSet_prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/plugins/logical.js
var logical_alternativeProps = {
  marginBlockStart: ['WebkitMarginBefore'],
  marginBlockEnd: ['WebkitMarginAfter'],
  marginInlineStart: ['WebkitMarginStart', 'MozMarginStart'],
  marginInlineEnd: ['WebkitMarginEnd', 'MozMarginEnd'],
  paddingBlockStart: ['WebkitPaddingBefore'],
  paddingBlockEnd: ['WebkitPaddingAfter'],
  paddingInlineStart: ['WebkitPaddingStart', 'MozPaddingStart'],
  paddingInlineEnd: ['WebkitPaddingEnd', 'MozPaddingEnd'],
  borderBlockStart: ['WebkitBorderBefore'],
  borderBlockStartColor: ['WebkitBorderBeforeColor'],
  borderBlockStartStyle: ['WebkitBorderBeforeStyle'],
  borderBlockStartWidth: ['WebkitBorderBeforeWidth'],
  borderBlockEnd: ['WebkitBorderAfter'],
  borderBlockEndColor: ['WebkitBorderAfterColor'],
  borderBlockEndStyle: ['WebkitBorderAfterStyle'],
  borderBlockEndWidth: ['WebkitBorderAfterWidth'],
  borderInlineStart: ['WebkitBorderStart', 'MozBorderStart'],
  borderInlineStartColor: ['WebkitBorderStartColor', 'MozBorderStartColor'],
  borderInlineStartStyle: ['WebkitBorderStartStyle', 'MozBorderStartStyle'],
  borderInlineStartWidth: ['WebkitBorderStartWidth', 'MozBorderStartWidth'],
  borderInlineEnd: ['WebkitBorderEnd', 'MozBorderEnd'],
  borderInlineEndColor: ['WebkitBorderEndColor', 'MozBorderEndColor'],
  borderInlineEndStyle: ['WebkitBorderEndStyle', 'MozBorderEndStyle'],
  borderInlineEndWidth: ['WebkitBorderEndWidth', 'MozBorderEndWidth']
};

function logical(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(logical_alternativeProps, property)) {
    var alternativePropList = logical_alternativeProps[property];
    for (var i = 0, len = alternativePropList.length; i < len; ++i) {
      style[alternativePropList[i]] = value;
    }
  }
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/plugins/position.js
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/plugins/sizing.js
var sizing_prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var sizing_values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && sizing_values.hasOwnProperty(value)) {
    return sizing_prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
// EXTERNAL MODULE: ./node_modules/_css-in-js-utils@2.0.1@css-in-js-utils/lib/hyphenateProperty.js
var hyphenateProperty = __webpack_require__(5);
var hyphenateProperty_default = /*#__PURE__*/__webpack_require__.n(hyphenateProperty);

// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/plugins/transition.js





var transition_properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};

var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function transition_prefixValue(value, propertyPrefixMap) {
  if (isPrefixedValue_default()(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = hyphenateProperty_default()(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && transition_properties.hasOwnProperty(property)) {
    var outputValue = transition_prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + capitalizeString(property)] = webkitOutput;
    style['Moz' + capitalizeString(property)] = mozOutput;
    return outputValue;
  }
}
// CONCATENATED MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/es/index.js


















var es_plugins = [backgroundClip, crossFade, cursor, filter_filter, flexboxOld, gradient, grid, imageSet, logical, position, sizing, transition, flex_flex];

var es_prefix = createPrefixer({
  prefixMap: es_data.prefixMap,
  plugins: es_plugins
});


// EXTERNAL MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/lib/plugins/backgroundClip.js
var plugins_backgroundClip = __webpack_require__(6);
var backgroundClip_default = /*#__PURE__*/__webpack_require__.n(plugins_backgroundClip);

// EXTERNAL MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/lib/plugins/flex.js
var plugins_flex = __webpack_require__(7);
var flex_default = /*#__PURE__*/__webpack_require__.n(plugins_flex);

// EXTERNAL MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/lib/plugins/flexboxOld.js
var plugins_flexboxOld = __webpack_require__(8);
var flexboxOld_default = /*#__PURE__*/__webpack_require__.n(plugins_flexboxOld);

// EXTERNAL MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/lib/plugins/gradient.js
var plugins_gradient = __webpack_require__(9);
var gradient_default = /*#__PURE__*/__webpack_require__.n(plugins_gradient);

// EXTERNAL MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/lib/plugins/logical.js
var plugins_logical = __webpack_require__(10);
var logical_default = /*#__PURE__*/__webpack_require__.n(plugins_logical);

// EXTERNAL MODULE: ./node_modules/_inline-style-prefixer@5.1.2@inline-style-prefixer/lib/plugins/position.js
var plugins_position = __webpack_require__(11);
var position_default = /*#__PURE__*/__webpack_require__.n(plugins_position);

// CONCATENATED MODULE: ./scripts/prefixer-generator/prefixData.js






var prefixData_w = ["Webkit"];
var prefixData_m = ["Moz"];
var prefixData_ms = ["ms"];
var prefixData_wm = ["Webkit", "Moz"];
var prefixData_wms = ["Webkit", "ms"];
var prefixData_wmms = ["Webkit", "Moz", "ms"];

/* harmony default export */ var prefixData = ({
  plugins: [backgroundClip_default.a, flex_default.a, flexboxOld_default.a, gradient_default.a, logical_default.a, position_default.a],
  prefixMap: { "appearance": prefixData_w, "userSelect": prefixData_w, "textEmphasisPosition": prefixData_w, "textEmphasis": prefixData_w, "textEmphasisStyle": prefixData_w, "textEmphasisColor": prefixData_w, "boxDecorationBreak": prefixData_w, "clipPath": prefixData_w, "maskImage": prefixData_w, "maskMode": prefixData_w, "maskRepeat": prefixData_w, "maskPosition": prefixData_w, "maskClip": prefixData_w, "maskOrigin": prefixData_w, "maskSize": prefixData_w, "maskComposite": prefixData_w, "mask": prefixData_w, "maskBorderSource": prefixData_w, "maskBorderMode": prefixData_w, "maskBorderSlice": prefixData_w, "maskBorderWidth": prefixData_w, "maskBorderOutset": prefixData_w, "maskBorderRepeat": prefixData_w, "maskBorder": prefixData_w, "maskType": prefixData_w, "textDecorationStyle": prefixData_w, "textDecorationSkip": prefixData_w, "textDecorationLine": prefixData_w, "textDecorationColor": prefixData_w, "filter": prefixData_w, "fontFeatureSettings": prefixData_w, "breakAfter": prefixData_w, "breakBefore": prefixData_w, "breakInside": prefixData_w, "columnCount": prefixData_w, "columnFill": prefixData_w, "columnGap": prefixData_w, "columnRule": prefixData_w, "columnRuleColor": prefixData_w, "columnRuleStyle": prefixData_w, "columnRuleWidth": prefixData_w, "columns": prefixData_w, "columnSpan": prefixData_w, "columnWidth": prefixData_w, "writingMode": prefixData_w, "flex": prefixData_w, "flexBasis": prefixData_w, "flexDirection": prefixData_w, "flexGrow": prefixData_w, "flexFlow": prefixData_w, "flexShrink": prefixData_w, "flexWrap": prefixData_w, "alignContent": prefixData_w, "alignItems": prefixData_w, "alignSelf": prefixData_w, "justifyContent": prefixData_w, "order": prefixData_w, "transform": prefixData_w, "transformOrigin": prefixData_w, "transformOriginX": prefixData_w, "transformOriginY": prefixData_w, "backfaceVisibility": prefixData_w, "perspective": prefixData_w, "perspectiveOrigin": prefixData_w, "transformStyle": prefixData_w, "transformOriginZ": prefixData_w, "animation": prefixData_w, "animationDelay": prefixData_w, "animationDirection": prefixData_w, "animationFillMode": prefixData_w, "animationDuration": prefixData_w, "animationIterationCount": prefixData_w, "animationName": prefixData_w, "animationPlayState": prefixData_w, "animationTimingFunction": prefixData_w, "backdropFilter": prefixData_w, "fontKerning": prefixData_w, "scrollSnapType": prefixData_w, "scrollSnapPointsX": prefixData_w, "scrollSnapPointsY": prefixData_w, "scrollSnapDestination": prefixData_w, "scrollSnapCoordinate": prefixData_w, "textSizeAdjust": prefixData_w, "shapeImageThreshold": prefixData_w, "shapeImageMargin": prefixData_w, "shapeImageOutside": prefixData_w, "hyphens": prefixData_w, "flowInto": prefixData_w, "flowFrom": prefixData_w, "regionFragment": prefixData_w, "borderImage": prefixData_w, "borderImageOutset": prefixData_w, "borderImageRepeat": prefixData_w, "borderImageSlice": prefixData_w, "borderImageSource": prefixData_w, "borderImageWidth": prefixData_w, "transitionDelay": prefixData_w, "transitionDuration": prefixData_w, "transitionProperty": prefixData_w, "transitionTimingFunction": prefixData_w }
});
// CONCATENATED MODULE: ./src/utils/prefixer.js




var prefixer_prefix = createPrefixer(prefixData);

/* harmony default export */ var prefixer = (function (styleObject) {
  return prefixer_prefix(styleObject);
});
// CONCATENATED MODULE: ./src/BaseView.jsx
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var noop = function noop() {};

// 是否内部变量
var isInnerProp = function isInnerProp(key) {
  return key && key[0] === '_';
};

// 是否模版参数
var isTemplateProp = function isTemplateProp(key) {
  return key !== 'children' && key !== 'dinamic';
};

/* ------------------------------------------------------------ */

var BaseView_View = function (_Dinamic$Component) {
  _inherits(View, _Dinamic$Component);

  function View(props) {
    _classCallCheck(this, View);

    /* ------------------------------------------------------------ */

    // View基础样式
    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));

    _this.getStyles = function () {
      var styleGetter = createGetter.call(_this, 'styles');

      return function () {
        var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

        return this.styleParser(styleGetter(groupId));
      };
    }();

    _this.setStyles = createSetter.call(_this, 'styles');
    _this.getAttrs = createGetter.call(_this, 'attrs');
    _this.setAttrs = createSetter.call(_this, 'attrs');
    _this.getEvents = createGetter.call(_this, 'events');
    _this.setEvents = createSetter.call(_this, 'events');
    _this.setStyles({
      position: 'relative',
      display: 'flex'
    });

    /* ------------------------------------------------------------ */

    // 获取 layout props
    _this.layoutProps = getLayoutProps.call(_this);
    if (_this.layoutProps) {
      var _this$layoutProps = _this.layoutProps,
          _viewName = _this$layoutProps._viewName,
          childrenLen = _this$layoutProps.childrenLen;


      if (_viewName === 'FrameLayout') {
        var enableExperimentalRender = dinamic_root_Dinamic_["getGlobalConfig"]('enableExperimentalRender');
        // 依赖 dinamic 升级，老版本没有 childrenLen 字段，额外判断 undefined
        // 仅有一个子节点的情况不使用 absloute 定位
        if (!enableExperimentalRender || childrenLen === 'undefined' || childrenLen > 1) {
          _this.setStyles({
            position: 'absolute'
          });
        }
      } else if (_viewName === 'LinearLayout') {
        // 子节点如果不设置权重，默认加上不伸缩
        _this.setStyles({
          flexShrink: 0,
          flexGrow: 0
        });
      }
    }

    decorateRender.call(_this);

    decorateLifeCycle.call(_this);

    decorateCalcLayoutSize.call(_this);
    return _this;
  }

  _createClass(View, [{
    key: 'getChildren',
    value: function getChildren() {
      // 兼容rax下 children非数组的场景
      var children = this.props.children;

      if (Array.isArray(children)) {
        return children;
      } else if (isObject(children)) {
        return [children];
      }

      return [];
    }
  }, {
    key: 'getTemplateId',
    value: function getTemplateId() {
      return this.props._tplId;
    }
  }, {
    key: 'getViewName',
    value: function getViewName() {
      return this.props._viewName;
    }
  }, {
    key: 'styleParser',
    value: function styleParser(styleObject) {
      var styles = prefixer(styleObject);
      for (var attr in styles) {
        var val = styles[attr];
        if (Array.isArray(val)) {
          styles[attr] = chooseCssValue(attr, val);
        }
      }

      return styles;
    }
  }, {
    key: 'propParser',
    value: function propParser(nextProps) {
      var _this2 = this;

      var cacheProps = [];
      var curProps = nextProps || this.props;

      for (var key in curProps) {
        var value = curProps[key];

        if (isInnerProp(key)) {
          continue;
        } else if (isTemplateProp(key)) {
          var propSetter = this[key];

          if (!propSetter) {
            continue;
          }

          if (Array.isArray(propSetter) && propSetter.length > 1) {
            // 按顺序解析依赖属性，并创建缓存队列
            propSetter.slice(0, -1).forEach(function (depKey) {
              var depSetter = _this2[depKey];

              // 如果已经被缓存，不重复执行
              // 如果 setter不是function，则跳过
              if (cacheProps.indexOf(depKey) !== -1 || !isFunction(depSetter)) {
                return;
              }
              var depValue = curProps[depKey];

              depSetter.call(_this2, depValue);

              cacheProps.push(depKey);
            });

            // 解析目标属性
            propSetter.slice(-1)[0].call(this, value);
          } else {
            if (cacheProps.indexOf(key) !== -1) {
              continue;
            }

            propSetter.call(this, value, curProps);

            cacheProps.push(key);
          }
        }
      }
    }
  }]);

  return View;
}(dinamic_root_Dinamic_["Component"]);

function createGetter(type) {
  var _this3 = this;

  return function () {
    var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

    return Object.assign({}, _this3[type][groupId]) || {};
  };
}

function createSetter(type) {
  var _this4 = this;

  this[type] = this[type] || {};

  return function (values) {
    var groupId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';

    _this4[type][groupId] = Object.assign(_this4[type][groupId] || {}, values);
  };
}

function setIndexMapContext() {
  var _props = this.props,
      _id = _props._id,
      _tplContext = _props._tplContext;
  var componentIndexSet = _tplContext.componentIndexSet;


  for (var i = componentIndexSet.length - 1; i >= 0; i--) {
    var id = componentIndexSet[i].id;


    if (id === _id) {
      componentIndexSet[i].context = this;
      return;
    }
  }
}

function bindEventListeners() {
  var _this5 = this;

  var componentWillBindEvent = this.props._tplContext.lifeCycles.componentWillBindEvent;


  var $el = external_amd_react_dom_commonjs_react_dom_commonjs2_react_dom_root_ReactDOM_default.a.findDOMNode(this);
  if (!$el) {
    return false;
  }

  var events = this.getEvents();
  if (Object.keys(events).length > 0) {
    var eventFactory = utils_bindGestureEvent($el);

    var _loop = function _loop(eventName) {
      var event = events[eventName];

      // 模版事件绑定回调触发
      componentWillBindEvent.call(_this5, event, $el);

      if (event) {
        eventFactory.on(eventName, function (e) {

          // 重新获取事件引用，数据变更后，引用会变化
          var events = _this5.getEvents();
          event = events[eventName];
          event.handler(e);
        });
      }
    };

    for (var eventName in events) {
      _loop(eventName);
    }
  }
}

function getLayoutProps() {
  var _props2 = this.props,
      _tplContext = _props2._tplContext,
      _id = _props2._id;
  var componentIndexSet = _tplContext.componentIndexSet;


  for (var i = componentIndexSet.length - 1; i >= 0; i--) {
    var _componentIndexSet$i = componentIndexSet[i],
        id = _componentIndexSet$i.id,
        pid = _componentIndexSet$i.pid;


    if (id === _id) {
      if (!pid) {
        break;
      }
      for (var j = i - 1; j >= 0; j--) {
        var _componentIndexSet$j = componentIndexSet[j],
            layoutId = _componentIndexSet$j.id,
            props = _componentIndexSet$j.props;


        if (pid === layoutId) {
          return props;
        }
      }
    }
  }

  return null;
}

var taskCache = {};
function decorateCalcLayoutSize() {
  var _tplContext = this.props._tplContext;
  var componentIndexSet = _tplContext.componentIndexSet,
      lifeCycles = _tplContext.lifeCycles;


  var tplId = this.getTemplateId();
  var shouldSplitLayoutTask = dinamic_root_Dinamic_["getGlobalConfig"]('shouldSplitLayoutTask');

  this.calcLayoutSize = function () {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    var taskId = taskCache[tplId];

    if (taskId) {
      window.clearTimeout(taskId);
    }

    taskCache[tplId] = setTimeout(function () {
      var _loop2 = function _loop2(i) {
        var context = componentIndexSet[i].context;


        if (context && context.dynamicCalcSize) {
          if (shouldSplitLayoutTask) {
            var taskRunner = runframeTask(callback);

            taskRunner(function () {
              return context.dynamicCalcSize();
            });
          } else {
            context.dynamicCalcSize();
          }
        }
      };

      for (var i = componentIndexSet.length - 1; i >= 0; i--) {
        _loop2(i);
      }

      if (!shouldSplitLayoutTask) {
        callback();
      }
    }, 0);
  };
}

function decorateRender() {
  var _this6 = this;

  var subRenderView = this.render || noop;

  this.render = function () {
    var props = _this6.props;

    // 渲染前绑定上下文，使所有控件均可在渲染结束后调用 calc
    setIndexMapContext.call(_this6);

    return dinamic_root_Dinamic_["h"](
      'div',
      _extends({
        key: props._id,
        'view-name': _this6.getViewName(),
        style: _this6.getStyles()
      }, _this6.getAttrs()),
      _this6.renderView ? _this6.renderView(props) : subRenderView.call(_this6, props)
    );
  };
}

function decorateLifeCycle() {
  var _this7 = this;

  var defaultHooks = {
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {

      // 只有view才进行比较，layout无差别更新
      // 有state情况下，无差别更新
      if (!nextState && !nextProps.children && isEqual(nextProps, _this7.props)) {
        return false;
      }

      // 每次更新前，调用预处理程序
      _this7.propParser(nextProps);

      return true;
    },
    componentWillMount: function componentWillMount() {
      // 首次创建dom前，调起预处理程序
      _this7.propParser();
    },
    componentDidMount: function componentDidMount() {
      var _props$_tplContext = _this7.props._tplContext,
          lifeCycles = _props$_tplContext.lifeCycles,
          shadow = _props$_tplContext.shadow;
      var componentFinishFirstPaint = lifeCycles.componentFinishFirstPaint;

      componentFinishFirstPaint.call(_this7, _this7.dxCompId, external_amd_react_dom_commonjs_react_dom_commonjs2_react_dom_root_ReactDOM_default.a.findDOMNode(_this7), shadow, {
        bindData: _this7._bindData
      });

      // 绑定所有手势事件
      bindEventListeners.call(_this7);
    },
    componentWillUnmount: noop,
    componentWillReceiveProps: noop,

    // deprecated - rax支持后会更新为
    componentWillUpdate: noop,
    componentDidUpdate: noop
  };

  var _loop3 = function _loop3(hookName) {
    var hookFunc = defaultHooks[hookName];
    var childHookFunc = _this7[hookName] || function () {};

    _this7[hookName] = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var parentResult = hookFunc.apply(_this7, args);
      var childResult = childHookFunc.apply(_this7, args);

      return childResult || parentResult;
    };
  };

  for (var hookName in defaultHooks) {
    _loop3(hookName);
  }
}

/* ------------------------------------------------------------ */
BaseView_View.defaultProps = {
  gravity: 'leftTop'
};

/* harmony default export */ var BaseView = (BaseView_View);
// CONCATENATED MODULE: ./src/components/View.jsx
var View_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function View_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function View_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function View_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var utils = dinamic_root_Dinamic_["utils"];
var isIOS = utils.env.isIOS;

// TODO: use decorator

function isFlexLayoutChild() {
  var layoutProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _viewName = layoutProps._viewName;


  return _viewName === 'FlexLayout';
}

var View_View = function (_BaseView) {
  View_inherits(View, _BaseView);

  function View() {
    var _ref;

    var _temp, _this, _ret;

    View_classCallCheck(this, View);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = View_possibleConstructorReturn(this, (_ref = View.__proto__ || Object.getPrototypeOf(View)).call.apply(_ref, [this].concat(args))), _this), _this.width = ['marginLeft', 'marginRight', function (propValue) {
      var _getStyles = this.getStyles(),
          marginLeft = _getStyles.marginLeft,
          marginRight = _getStyles.marginRight;

      var tempStyle = {};
      switch (propValue) {
        case 'match_parent':
          tempStyle.width = '100%';
          if (marginLeft || marginRight) {
            tempStyle.maxWidth = 'calc(100% - ' + (marginLeft || '0px') + ' - ' + (marginRight || '0px') + ')';
          }
          break;
        case 'match_content':
          tempStyle.width = 'fit-content';
          break;
        default:
          tempStyle.width = dinamic_root_Dinamic_["unitParser"](propValue);
      }

      this.setStyles(tempStyle);
    }], _this.height = ['marginTop', 'marginBottom', function (propValue) {
      var _getStyles2 = this.getStyles(),
          marginTop = _getStyles2.marginTop,
          marginBottom = _getStyles2.marginBottom;

      var tempStyle = {};
      switch (propValue) {
        case 'match_parent':
          tempStyle.height = '100%';
          if (marginTop || marginBottom) {
            tempStyle.maxHeight = 'calc(100% - ' + (marginTop || '0px') + ' - ' + (marginBottom || '0px') + ')';
          }
          break;
        case 'match_content':
          tempStyle.height = 'auto';
          break;
        default:
          tempStyle.height = dinamic_root_Dinamic_["unitParser"](propValue);
      }

      this.setStyles(tempStyle);
    }], _temp), View_possibleConstructorReturn(_this, _ret);
  }

  View_createClass(View, [{
    key: 'dx-compid',
    value: function dxCompid(propValue) {
      this.setAttrs({ 'dx-compid': propValue });
    }
    // 用户指定的字符串标识，必须在模板内唯一（相当于控件id）

  }, {
    key: 'userId',
    value: function userId(propValue) {
      this.dxCompId = propValue;
      this.setAttrs({ 'data-comp-id': propValue });
    }
  }, {
    key: 'minHeight',
    value: function minHeight(propValue) {
      this.setStyles({
        minHeight: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'marginLeft',
    value: function marginLeft(propValue) {
      this.setStyles({
        marginLeft: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'marginRight',
    value: function marginRight(propValue) {
      this.setStyles({
        marginRight: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'marginTop',
    value: function marginTop(propValue) {
      this.setStyles({
        marginTop: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'marginBottom',
    value: function marginBottom(propValue) {
      this.setStyles({
        marginBottom: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'gravity',
    value: function gravity(propValue) {

      // 如果不是layout的子节点，则忽略 dGravity
      if (!this.layoutProps) {
        return;
      }
      var result = {};
      var _layoutProps = this.layoutProps,
          layoutName = _layoutProps._viewName,
          orientation = _layoutProps.orientation,
          childrenLen = _layoutProps.childrenLen;

      var _parseGravity = parseGravity(propValue),
          x = _parseGravity.x,
          y = _parseGravity.y;

      if (layoutName === 'FrameLayout') {
        var enableExperimentalRender = dinamic_root_Dinamic_["getGlobalConfig"]('enableExperimentalRender');
        if (!enableExperimentalRender || childrenLen === 'undefined' || childrenLen > 1) {
          var _result;

          var gravMap = {
            center: '0px'
          };

          result = (_result = {}, _defineProperty(_result, x === 'center' ? 'left' : x, gravMap[x] || 0), _defineProperty(_result, y === 'center' ? 'top' : y, gravMap[y] || 0), _result);
        }
      } else if (layoutName === 'LinearLayout') {
        var _gravMap = {
          left: 'flex-start',
          top: 'flex-start',
          right: 'flex-end',
          bottom: 'flex-end',
          center: 'center'
        };

        var tmp = [_gravMap[x], _gravMap[y]];
        if (!orientation || orientation === 'horizontal') {
          tmp = tmp.reverse();
        }

        result = {
          alignSelf: tmp[0],
          justifySelf: tmp[1]
        };
      }

      this.setStyles(result);
    }
  }, {
    key: 'backgroundColor',
    value: function backgroundColor(propValue) {
      this.setStyles({
        backgroundColor: dinamic_root_Dinamic_["colorParser"](propValue)
      });
    }
  }, {
    key: 'backgroundGradient',
    value: function backgroundGradient(propValue) {
      if (propValue) {
        this.setStyles({
          backgroundImage: propValue
        });
      }
    }
  }, {
    key: 'alpha',
    value: function alpha(propValue) {
      this.setStyles({
        opacity: propValue
      });
    }
  }, {
    key: 'visibility',
    value: function visibility(propValue) {
      var tempStyle = {
        display: 'flex'
      };
      switch (propValue) {
        case 'gone':
          tempStyle.display = 'none';
          break;
        case 'invisible':
          tempStyle.visibility = 'hidden';
          break;
        case 'visible':
          tempStyle.visibility = 'visible';
      }

      this.setStyles(tempStyle);
    }
  }, {
    key: 'cornerRadius',
    value: function cornerRadius(propValue) {
      this.setStyles({
        borderRadius: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'cornerRadiusLeftTop',
    value: function cornerRadiusLeftTop(propValue) {
      this.setStyles({
        borderTopLeftRadius: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'cornerRadiusRightTop',
    value: function cornerRadiusRightTop(propValue) {
      this.setStyles({
        borderTopRightRadius: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'cornerRadiusLeftBottom',
    value: function cornerRadiusLeftBottom(propValue) {
      this.setStyles({
        borderBottomLeftRadius: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'cornerRadiusRightBottom',
    value: function cornerRadiusRightBottom(propValue) {
      this.setStyles({
        borderBottomRightRadius: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'borderWidth',
    value: function borderWidth(propValue, curProps) {
      var _ref2 = curProps || this.props,
          borderColor = _ref2.borderColor;

      var parsedBorderWidth = dinamic_root_Dinamic_["unitParser"](propValue);
      var parsedBorderColor = dinamic_root_Dinamic_["colorParser"](borderColor);

      // 许多环境不支持 < 1px 的 box-shadow
      // 所以先将 < 1px 的边框转回border
      if (parseFloat(parsedBorderWidth) < 1) {

        // ios 支持 < 1px 边框展示，其他则降级为1px
        this.setStyles({
          border: parsedBorderWidth + ' solid ' + parsedBorderColor
        });
      } else {

        // 使用 box-shadow 去模拟无宽度的边框，主要是为了三端统一
        // 由于Native border内伸展且不计算宽度（原因参见官网文档），此处采用inset box-shadow模拟
        this.setStyles({
          boxShadow: 'inset 0 0 0 ' + parsedBorderWidth + ' ' + parsedBorderColor
        });
      }
    }
  }, {
    key: 'accessibilityText',
    value: function accessibilityText(propValue) {
      this.setAttrs({
        'aria-label': propValue
      });
    }
  }, {
    key: 'focusable',
    value: function focusable(propValue) {}
  }, {
    key: 'weight',
    value: function weight(propValue) {
      this.setStyles({
        flex: propValue
      });
    }
  }, {
    key: 'clipTopLeftRadius',
    value: function clipTopLeftRadius(propValue) {
      this.setStyles({
        overflow: 'hidden',
        borderTopLeftRadius: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'clipTopRightRadius',
    value: function clipTopRightRadius(propValue) {
      this.setStyles({
        overflow: 'hidden',
        borderTopRightRadius: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'clipBottomLeftRadius',
    value: function clipBottomLeftRadius(propValue) {
      this.setStyles({
        overflow: 'hidden',
        borderBottomLeftRadius: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'clipBottomRightRadius',
    value: function clipBottomRightRadius(propValue) {
      this.setStyles({
        overflow: 'hidden',
        borderBottomRightRadius: dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }

    /* ------------------------------------------------------------ */
    /* Flex Item 相关属性 */

  }, {
    key: 'order',
    value: function order(propValue) {
      if (!isFlexLayoutChild(this.layoutProps)) return;

      this.setStyles({
        order: propValue
      });
    }
  }, {
    key: 'flexGrow',
    value: function flexGrow(propValue) {
      if (!isFlexLayoutChild(this.layoutProps)) return;

      this.setStyles({
        flexGrow: propValue
      });
    }
  }, {
    key: 'flexShrink',
    value: function flexShrink(propValue) {
      if (!isFlexLayoutChild(this.layoutProps)) return;

      this.setStyles({
        flexShrink: propValue
      });
    }
  }, {
    key: 'flexBasis',
    value: function flexBasis(propValue) {
      if (!isFlexLayoutChild(this.layoutProps)) return;

      this.setStyles({
        flexBasis: propValue
      });
    }
  }, {
    key: 'flex',
    value: function flex(propValue) {
      if (!isFlexLayoutChild(this.layoutProps)) return;

      this.setStyles({
        flex: propValue
      });
    }
  }, {
    key: 'alignSelf',
    value: function alignSelf(propValue) {
      if (!isFlexLayoutChild(this.layoutProps)) return;

      this.setStyles({
        alignSelf: propValue
      });
    }

    /* ------------------------------------------------------------ */
    /* 事件 */

  }, {
    key: 'onBindData',
    value: function onBindData(event) {
      this._bindData = event.handler();
    }
  }, {
    key: 'onTap',
    value: function onTap(propValue) {
      this.setEvents({
        tap: propValue
      });
    }
  }, {
    key: 'onLongTap',
    value: function onLongTap(propValue) {
      this.setEvents({
        longTap: propValue
      });
    }
  }, {
    key: 'onPanBegin',
    value: function onPanBegin(propValue) {
      this.setEvents({
        panBegin: propValue
      });
    }
  }, {
    key: 'onPanMove',
    value: function onPanMove(propValue) {
      this.setEvents({
        panMove: propValue
      });
    }
  }, {
    key: 'onPanEnd',
    value: function onPanEnd(propValue) {
      this.setEvents({
        panEnd: propValue
      });
    }
  }]);

  return View;
}(BaseView);

;

dinamic_root_Dinamic_["registerView"]('View', View_View);
dinamic_root_Dinamic_["registerView"]('DView', View_View);

/* harmony default export */ var components_View = (View_View);
// CONCATENATED MODULE: ./src/components/Layout.jsx
var Layout_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Layout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Layout_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Layout_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Layout_Layout = function (_View) {
  Layout_inherits(Layout, _View);

  function Layout(props) {
    Layout_classCallCheck(this, Layout);

    // layout边界限制
    var _this = Layout_possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this, props));

    _this.setStyles({ overflow: 'hidden' });
    return _this;
  }

  Layout_createClass(Layout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // 初始化计算frame
      // 只有根节点渲染完成后执行一次重计算
      // 此处需执行三次重计算，解决循环依赖下的计算问题
      // 第一次主要完成初始计算，第二次修正计算宽度相关内容，第三次修正计算高度相关内容
      if (this.layoutProps === null) {
        this.calcLayoutSize(function () {
          return _this2.calcLayoutSize(function () {
            return _this2.calcLayoutSize();
          });
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this3 = this;

      if (this.layoutProps === null) {
        this.calcLayoutSize(function () {
          return _this3.calcLayoutSize(function () {
            return _this3.calcLayoutSize();
          });
        });
      }
    }
  }, {
    key: 'paddingLeft',
    value: function paddingLeft(propValue) {
      this.setStyles({
        paddingLeft: dinamic_root_Dinamic_default.a.unitParser(propValue)
      });
    }
  }, {
    key: 'paddingTop',
    value: function paddingTop(propValue) {
      this.setStyles({
        paddingTop: dinamic_root_Dinamic_default.a.unitParser(propValue)
      });
    }
  }, {
    key: 'paddingRight',
    value: function paddingRight(propValue) {
      this.setStyles({
        paddingRight: dinamic_root_Dinamic_default.a.unitParser(propValue)
      });
    }
  }, {
    key: 'paddingBottom',
    value: function paddingBottom(propValue) {
      this.setStyles({
        paddingBottom: dinamic_root_Dinamic_default.a.unitParser(propValue)
      });
    }
  }]);

  return Layout;
}(components_View);

/* harmony default export */ var components_Layout = (Layout_Layout);
// CONCATENATED MODULE: ./src/components/FrameLayout.jsx
var FrameLayout_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function FrameLayout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FrameLayout_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function FrameLayout_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








function calcFrameSize(frameElement) {
  var isMatchContentWidth = this.props.width === 'match_content';
  var isMatchContentHeight = this.props.height === 'match_content';

  // 固定宽高，则放弃计算
  if (!isMatchContentWidth && !isMatchContentHeight) {
    return null;
  } else {
    if (isMatchContentWidth) {

      // 清空宽度设置，防止frame限制内层
      frameElement.style.width = 'auto';
    }

    if (isMatchContentHeight) {
      frameElement.style.height = 'auto';
    }
  }

  var maxWidth = -1;
  var maxHeight = -1;

  var frameChildren = frameElement.childNodes || [];
  var childrenLength = frameChildren.length;
  var vdomChildren = this.getChildren();
  for (var i = 0; i < childrenLength; i++) {
    var el = frameChildren[i];

    // 排除不可见元素
    if (el.nodeType !== Node.ELEMENT_NODE && el.nodeType !== Node.TEXT_NODE) {
      continue;
    }

    // 只有一个child时，children是对象而非数组
    var childProps = vdomChildren[i].props || {};

    // 1. 排除不可见元素
    // 2. 排除宽度是适应父级的元素
    if (isMatchContentWidth && childProps.width === 'match_parent' || isMatchContentHeight && childProps.height === 'match_parent' || isElementInvisable(el)) {
      continue;
    }

    var rect = el.getBoundingClientRect();
    var _rect$width = rect.width,
        width = _rect$width === undefined ? el.offsetWidth : _rect$width,
        _rect$height = rect.height,
        height = _rect$height === undefined ? el.offsetHeight : _rect$height;

    // 所有不占位隐藏的子节点，需要计算margin

    if (el.style && el.style.display !== 'none') {
      if (el.style.marginLeft) {
        width += parseFloat(el.style.marginLeft) || 0;
      }
      if (el.style.marginRight) {
        width += parseFloat(el.style.marginRight) || 0;
      }

      if (el.style.marginTop) {
        height += parseFloat(el.style.marginTop) || 0;
      }
      if (el.style.marginBottom) {
        height += parseFloat(el.style.marginBottom) || 0;
      }
    }

    maxWidth = Math.max(width, maxWidth);
    maxHeight = Math.max(height, maxHeight);
  }

  var staticFrameSize = frameElement.getBoundingClientRect();
  return {
    width: numTrunc(isMatchContentWidth ? maxWidth : staticFrameSize.width),
    height: numTrunc(isMatchContentHeight ? maxHeight : staticFrameSize.height)
  };
}

function calcSubChildPositionAndMaxWidth(frameElement, frameSize) {
  var _ref = frameSize || frameElement.getBoundingClientRect(),
      frameWidth = _ref.width,
      frameHeight = _ref.height;

  var frameChildren = frameElement.childNodes || [];
  var componentChildren = this.getChildren();

  for (var i = 0; i < frameChildren.length; i++) {
    var el = frameChildren[i];
    var component = componentChildren[i];

    if (component && component.props) {
      // 位置计算
      var pos = component.props.gravity;
      var rect = el.getBoundingClientRect();

      var marginLeft = parseFloat(el.style.marginLeft) || 0;
      var marginRight = parseFloat(el.style.marginRight) || 0;
      var marginTop = parseFloat(el.style.marginTop) || 0;
      var marginBottom = parseFloat(el.style.marginBottom) || 0;

      // 横向总占位长度
      var hTotalLength = rect.width + marginLeft + marginRight;
      var vTotalLength = rect.height + marginTop + marginBottom;

      if (pos === 'center' || pos === 'leftCenter' || pos === 'rightCenter') {
        el.style.top = (frameHeight - vTotalLength) / 2 + 'px';
      }

      if (pos === 'center' || pos === 'centerTop' || pos === 'centerBottom') {
        el.style.left = (frameWidth - hTotalLength) / 2 + 'px';
      }
    }
  }
}

var FrameLayout_FrameLayout = function (_Layout) {
  FrameLayout_inherits(FrameLayout, _Layout);

  function FrameLayout(props) {
    FrameLayout_classCallCheck(this, FrameLayout);

    var _this = FrameLayout_possibleConstructorReturn(this, (FrameLayout.__proto__ || Object.getPrototypeOf(FrameLayout)).call(this, props));

    var enableExperimentalRender = dinamic_root_Dinamic_["getGlobalConfig"]('enableExperimentalRender');
    _this.shouldConvert2Flex = enableExperimentalRender && props.childrenLen <= 1;

    _this.updateFlexStyle();
    return _this;
  }

  FrameLayout_createClass(FrameLayout, [{
    key: 'updateFlexStyle',
    value: function updateFlexStyle() {
      var shouldConvert2Flex = this.shouldConvert2Flex,
          props = this.props;


      if (shouldConvert2Flex && props.children && props.children.props && props.children.props.gravity) {
        var gravity = props.children.props.gravity;

        var _parseGravity = parseGravity(gravity),
            x = _parseGravity.x,
            y = _parseGravity.y;

        var gravMap = {
          left: 'flex-start',
          top: 'flex-start',
          right: 'flex-end',
          bottom: 'flex-end',
          center: 'center'
        };

        this.setStyles({
          justifyContent: gravMap[x],
          alignItems: gravMap[y]
        });
      }
    }
  }, {
    key: 'dynamicCalcSize',
    value: function dynamicCalcSize() {
      if (this.shouldConvert2Flex) {
        return;
      }

      var frameElement = void 0;
      try {
        frameElement = external_amd_react_dom_commonjs_react_dom_commonjs2_react_dom_root_ReactDOM_default.a.findDOMNode(this);
      } catch (e) {
        dinamic_root_Dinamic_["utils"].log.warn(e);
        return;
      }

      // 动态计算frame宽高
      var dynamicFrameSize = calcFrameSize.call(this, frameElement);

      // 动态计算子节点位置
      // hack: 动态计算子 View 宽度，其实由于calc计算match_parent，此处已经不必要
      // 不过由于android < 4.4仍不支持calc，所以暂时保留
      calcSubChildPositionAndMaxWidth.call(this, frameElement, dynamicFrameSize);

      // 动态 frame
      if (dynamicFrameSize) {
        var width = dynamicFrameSize.width,
            height = dynamicFrameSize.height;


        frameElement.style.width = width + 'px';
        frameElement.style.height = height + 'px';
      }
    }
  }, {
    key: 'renderView',
    value: function renderView() {
      return this.props.children;
    }
  }]);

  return FrameLayout;
}(components_Layout);

dinamic_root_Dinamic_["registerView"]('FrameLayout', FrameLayout_FrameLayout);
dinamic_root_Dinamic_["registerView"]('DFrameLayout', FrameLayout_FrameLayout);

/* harmony default export */ var components_FrameLayout = (FrameLayout_FrameLayout);
// CONCATENATED MODULE: ./src/components/LinearLayout.jsx
var LinearLayout_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LinearLayout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LinearLayout_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LinearLayout_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function calcSubChildWidth(layoutElement) {
  var layoutChildren = layoutElement.childNodes || [];
  var childrenLen = layoutChildren.length;
  var layoutRect = layoutElement.getBoundingClientRect();
  var layoutWidth = layoutRect.width;

  var orientation = this.props.orientation;

  var totalWidth = 0;

  for (var i = 0; i < childrenLen; i++) {
    var el = layoutChildren[i];
    if (el.nodeType !== Node.ELEMENT_NODE && el.nodeType !== Node.TEXT_NODE) {
      continue;
    }

    // 开始计算子View宽度
    var rect = el.getBoundingClientRect();
    var marginLeft = parseFloat(el.style.marginLeft) || 0;
    var marginRight = parseFloat(el.style.marginRight) || 0;
    var hWidth = rect.width + marginLeft + marginRight;
    totalWidth += hWidth;

    // 1. 宽度为0的子元素，不占位；如已经为不可见元素，则不添加
    if (rect.width === 0 && el.style.flex && !isElementInvisable(el)) {
      el.style.display = 'none';
    }

    // 2. match_parent hack: 如果 子view 绝对外层宽度大于或等于layout宽度，则增加宽度自动缩放
    if (totalWidth > layoutWidth) {
      if (orientation === 'horizontal') {
        // 2.1 横向为主轴，用 flex-shrink做伸缩
        el.style.flexShrink = '1';
      } else {
        // 2.2 纵向为主轴时，flex-shrink失效，最大宽度计算，如果横向最大长度已经超出屏宽，则最后一个view的宽度压缩
        el.style.maxWidth = numTrunc(layoutWidth - marginLeft - marginRight) + 'px';
      }
    }
  }
}

var LinearLayout_LinearLayout = function (_Layout) {
  LinearLayout_inherits(LinearLayout, _Layout);

  function LinearLayout() {
    LinearLayout_classCallCheck(this, LinearLayout);

    return LinearLayout_possibleConstructorReturn(this, (LinearLayout.__proto__ || Object.getPrototypeOf(LinearLayout)).apply(this, arguments));
  }

  LinearLayout_createClass(LinearLayout, [{
    key: 'dynamicCalcSize',
    value: function dynamicCalcSize() {
      var shouldExecLinearLayoutHack = dinamic_root_Dinamic_["getGlobalConfig"]('shouldExecLinearLayoutHack');

      if (shouldExecLinearLayoutHack) {
        try {
          var layoutElement = external_amd_react_dom_commonjs_react_dom_commonjs2_react_dom_root_ReactDOM_default.a.findDOMNode(this);

          // hack: 动态计算子 View 宽度，其实由于calc计算match_parent，此处已经不必要
          // 不过由于android < 4.4仍不支持calc，所以暂时保留
          calcSubChildWidth.call(this, layoutElement);
        } catch (e) {
          dinamic_root_Dinamic_["utils"].log.warn(e);
        }
      }
    }
  }, {
    key: 'childGravity',
    value: function childGravity(propValue) {
      var orientation = this.props.orientation;


      var upperIndex = propValue.search(/[A-Z]/);

      var x = void 0,
          y = void 0;
      if (upperIndex !== -1) {
        x = propValue.slice(0, upperIndex);
        y = propValue.slice(upperIndex).toLowerCase();
      } else {
        x = y = propValue;
      }

      var gravMap = {
        left: 'flex-start',
        top: 'flex-start',
        right: 'flex-end',
        bottom: 'flex-end',
        center: 'center'
      };

      var tmp = [gravMap[x], gravMap[y]];
      if (!orientation || orientation === 'horizontal') {
        tmp = tmp.reverse();
      }

      this.setStyles({
        alignItems: tmp[0],
        justifyContent: tmp[1]
      });
    }
  }, {
    key: 'orientation',
    value: function orientation(propValue) {
      var flexDirection = void 0;

      if (propValue === 'horizontal') {
        flexDirection = 'row';
      } else {
        flexDirection = 'column';
      }

      this.setStyles({ flexDirection: flexDirection });
    }
  }, {
    key: 'renderView',
    value: function renderView() {
      return this.props.children;
    }
  }]);

  return LinearLayout;
}(components_Layout);

LinearLayout_LinearLayout.defaultProps = {
  orientation: 'horizontal'
};

dinamic_root_Dinamic_["registerView"]('LinearLayout', LinearLayout_LinearLayout);
dinamic_root_Dinamic_["registerView"]('DLinearLayout', LinearLayout_LinearLayout);

/* harmony default export */ var components_LinearLayout = (LinearLayout_LinearLayout);
// EXTERNAL MODULE: external {"amd":"react","commonjs":"react","commonjs2":"react","root":"React"}
var external_amd_react_commonjs_react_commonjs2_react_root_React_ = __webpack_require__(3);
var external_amd_react_commonjs_react_commonjs2_react_root_React_default = /*#__PURE__*/__webpack_require__.n(external_amd_react_commonjs_react_commonjs2_react_root_React_);

// CONCATENATED MODULE: ./src/utils/layout.js
var layout_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var REG_SUBDATA_EXP = /(\$|\@)?subdata/;
// 匹配带前缀的属性，暂时仅去掉 “d” 前缀
var REG_PROP_WITH_PREFIEX = /^[d][A-Z]/;

// hack：获取 prop setter，兼容 < 3.0.0 模版版本，会尝试去掉前缀
var removePropPrefix = function removePropPrefix(key) {
  if (REG_PROP_WITH_PREFIEX.test(key)) {
    var tempKey = key.slice(1);
    key = tempKey[0].toLowerCase() + tempKey.slice(1);
  }

  return key;
};
// 循环将subdata加入到子视图
function loopMergeSubData(view, subdata, index, pid) {
  var _this = this;

  if (!view) {
    return;
  }

  var tplId = this.props._tplId;
  var tplContext = this.props._tplContext;
  var props = view.props;

  var resultProps = layout_extends({
    key: props._id + '-' + index
  }, props);

  // 更新id
  var cid = resultProps._id = 'cc' + ++tplContext.componentIdSeq;

  var originProps = props._originProps;
  for (var key in originProps) {
    var propValue = originProps[key];
    var unPrefixKey = removePropPrefix(key);

    if (REG_SUBDATA_EXP.test(propValue)) {
      var options = { data: subdata, _tplId: tplId };
      if (unPrefixKey.slice(0, 2) === 'on') {
        resultProps[unPrefixKey] = dinamic_root_Dinamic_["eventHandlerParser"](propValue, options);
      } else {
        resultProps[unPrefixKey] = dinamic_root_Dinamic_["dataParser"](propValue, options);
      }
    }
  }

  // 插入索引表
  tplContext.componentIndexSet.push({
    id: cid,
    props: resultProps,
    pid: pid
  });

  var subViews = props.children;
  if (subViews) {
    if (Array.isArray(subViews)) {
      subViews = subViews.map(function (subView) {
        return loopMergeSubData.call(_this, subView, subdata, index, cid);
      });
    } else if (isObject(subViews)) {
      subViews = loopMergeSubData.call(this, subViews, subdata, index, cid);
    }
  }

  return external_amd_react_commonjs_react_commonjs2_react_root_React_default.a.cloneElement(view, resultProps, subViews);
}
// CONCATENATED MODULE: ./src/components/AdaptiveLinearLayout.jsx
var AdaptiveLinearLayout_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function AdaptiveLinearLayout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AdaptiveLinearLayout_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AdaptiveLinearLayout_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AdaptiveLinearLayout_AdaptiveLinearLayout = function (_LinearLayout) {
  AdaptiveLinearLayout_inherits(AdaptiveLinearLayout, _LinearLayout);

  function AdaptiveLinearLayout(props) {
    AdaptiveLinearLayout_classCallCheck(this, AdaptiveLinearLayout);

    return AdaptiveLinearLayout_possibleConstructorReturn(this, (AdaptiveLinearLayout.__proto__ || Object.getPrototypeOf(AdaptiveLinearLayout)).call(this, props));
  }

  AdaptiveLinearLayout_createClass(AdaptiveLinearLayout, [{
    key: 'listData',
    value: function listData(propsData) {
      this._listData = propsData;
    }
  }, {
    key: 'renderLoopChildren',
    value: function renderLoopChildren() {
      var _this2 = this;

      var subViews = [];
      var childrenViews = this.getChildren();
      var layoutProps = this.props;
      var tempStyle = {
        flexShrink: 0,
        flexGrow: 0,
        height: 'fit-content',
        paddingTop: 5,
        paddingBottom: 5
      };

      this._listData && this._listData.forEach(function (subdata, index) {
        childrenViews.forEach(function (sub) {
          var filter = sub.props._originProps.filter;
          var parsedFilter = filter && dinamic_root_Dinamic_["dataParser"](filter, { data: subdata });
          if (parsedFilter === undefined || parsedFilter === true || parsedFilter === 'true') {
            subViews.push(dinamic_root_Dinamic_["h"](
              'div',
              { key: index, className: 'list-item', style: tempStyle },
              loopMergeSubData.call(_this2, sub, subdata, index, layoutProps._id)
            ));
          }
        });
      });
      return subViews;
    }
  }, {
    key: 'renderView',
    value: function renderView() {
      var defaultStyle = {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap'
      };
      return dinamic_root_Dinamic_["h"](
        'div',
        { ref: 'adaptive', style: defaultStyle },
        this.renderLoopChildren()
      );
    }
  }]);

  return AdaptiveLinearLayout;
}(components_LinearLayout);

dinamic_root_Dinamic_["registerView"]('AdaptiveLinearLayout', AdaptiveLinearLayout_AdaptiveLinearLayout);

/* harmony default export */ var components_AdaptiveLinearLayout = (AdaptiveLinearLayout_AdaptiveLinearLayout);
// CONCATENATED MODULE: ./src/components/ListLayout.jsx
var ListLayout_slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var ListLayout_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var ListLayout_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function ListLayout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ListLayout_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ListLayout_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx Dinamic.h */








var ListLayout_REG_SUBDATA_EXP = /(\$|\@)?subdata/;

// 匹配带前缀的属性，暂时仅去掉 “d” 前缀
var ListLayout_REG_PROP_WITH_PREFIEX = /^[d][A-Z]/;

// hack：获取 prop setter，兼容 < 3.0.0 模版版本，会尝试去掉前缀
function ListLayout_removePropPrefix(key) {
  if (ListLayout_REG_PROP_WITH_PREFIEX.test(key)) {
    var tempKey = key.slice(1);
    key = tempKey[0].toLowerCase() + tempKey.slice(1);
  }

  return key;
}

function ListLayout_loopMergeSubData(view, subdata, index, pid) {
  var _this = this;

  if (!view) {
    return;
  }
  var tplId = this.props._tplId;
  var tplContext = this.props._tplContext;
  var props = view.props;

  var resultProps = ListLayout_extends({
    key: props._id + '-' + index
  }, props);

  // 更新id
  var cid = resultProps._id = 'cc' + ++tplContext.componentIdSeq;

  var originProps = props._originProps;
  for (var key in originProps) {
    var propValue = originProps[key];
    var unPrefixKey = ListLayout_removePropPrefix(key);

    if (ListLayout_REG_SUBDATA_EXP.test(propValue)) {
      var options = {
        data: subdata,
        _tplId: tplId
      };
      if (unPrefixKey.slice(0, 2) === 'on') {
        resultProps[unPrefixKey] = dinamic_root_Dinamic_["eventHandlerParser"](propValue, options);
      } else {
        resultProps[unPrefixKey] = dinamic_root_Dinamic_["dataParser"](propValue, options);
      }
    }
  }

  // 插入索引表
  tplContext.componentIndexSet.push({
    id: cid,
    props: resultProps,
    pid: pid
  });

  var subViews = props.children;
  if (subViews) {
    if (Array.isArray(subViews)) {
      subViews = subViews.map(function (subView) {
        return ListLayout_loopMergeSubData.call(_this, subView, subdata, index, cid);
      });
    } else if (isObject(subViews)) {
      subViews = ListLayout_loopMergeSubData.call(this, subViews, subdata, index, cid);
    }
  }

  return external_amd_react_commonjs_react_commonjs2_react_root_React_default.a.cloneElement(view, resultProps, subViews);
}

var ListLayout_ListLayout = function (_LinearLayout) {
  ListLayout_inherits(ListLayout, _LinearLayout);

  function ListLayout() {
    ListLayout_classCallCheck(this, ListLayout);

    return ListLayout_possibleConstructorReturn(this, (ListLayout.__proto__ || Object.getPrototypeOf(ListLayout)).apply(this, arguments));
  }

  ListLayout_createClass(ListLayout, [{
    key: 'listData',
    value: function listData(_listData) {
      this._listData = _listData;
    }
  }, {
    key: 'renderLoopChildren',
    value: function renderLoopChildren() {
      var _this3 = this;

      var subViews = [];
      var childrenViews = this.getChildren();
      var layoutProps = this.props;

      var tempStyle = {
        flexShrink: 0,
        flexGrow: 0,
        height: 'fit-content'
      };

      // 所有子节点增加 subdata 缓存
      if (Array.isArray(this._listData)) {
        this._listData.forEach(function (subdata, index) {
          childrenViews.forEach(function (sub) {
            var id = sub.props._id;
            var filter = sub.props._originProps.filter;

            var parsedFilter = filter && dinamic_root_Dinamic_["dataParser"](filter, { data: subdata });

            var subStyle = tempStyle;
            if (sub.props.weight) {
              subStyle = ListLayout_extends({}, tempStyle, {
                flex: sub.props.weight
              });
            }

            // 如果未设置filter或者filter命中，则复制此节点
            if (parsedFilter === undefined || parsedFilter === true || parsedFilter === 'true') {
              subViews.push(dinamic_root_Dinamic_["h"](
                'div',
                { key: id + '-' + index, className: 'list-item', style: subStyle },
                ListLayout_loopMergeSubData.call(_this3, sub, subdata, index, layoutProps._id)
              ));
            }
          });
        });
      }
      return subViews;
    }
  }, {
    key: 'renderView',
    value: function renderView() {
      return this.renderLoopChildren();
    }
  }]);

  return ListLayout;
}(components_LinearLayout);

ListLayout_ListLayout.defaultProps = {
  orientation: 'horizontal'
};

// LoopLinearLayout循环内获取数据
// data 为 listlayout 的外层data，options.data 才是当前 item 的 data
dinamic_root_Dinamic_["registerDataParser"]('subdata', function (_ref, data, options) {
  var _ref2 = ListLayout_slicedToArray(_ref, 1),
      exp = _ref2[0];

  if (!exp) {
    return options.data;
  }

  return deepGet(options.data, exp);
});

dinamic_root_Dinamic_["registerView"]('ListLayout', ListLayout_ListLayout);
dinamic_root_Dinamic_["registerView"]('DLoopLinearLayout', ListLayout_ListLayout);

/* harmony default export */ var components_ListLayout = (ListLayout_ListLayout);
// CONCATENATED MODULE: ./src/components/FlexLayout.jsx
var FlexLayout_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function FlexLayout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FlexLayout_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function FlexLayout_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var FlexLayout = function (_Layout) {
  FlexLayout_inherits(FlexLayout, _Layout);

  function FlexLayout() {
    FlexLayout_classCallCheck(this, FlexLayout);

    return FlexLayout_possibleConstructorReturn(this, (FlexLayout.__proto__ || Object.getPrototypeOf(FlexLayout)).apply(this, arguments));
  }

  FlexLayout_createClass(FlexLayout, [{
    key: 'flexDirection',
    value: function flexDirection(propValue) {
      this.setStyles({
        flexDirection: propValue
      });
    }
  }, {
    key: 'flexWrap',
    value: function flexWrap(propValue) {
      this.setStyles({
        flexWrap: propValue
      });
    }
  }, {
    key: 'justifyContent',
    value: function justifyContent(propValue) {
      this.setStyles({
        justifyContent: propValue
      });
    }
  }, {
    key: 'alignItems',
    value: function alignItems(propValue) {
      this.setStyles({
        alignItems: propValue
      });
    }
  }, {
    key: 'alignContent',
    value: function alignContent(propValue) {
      this.setStyles({
        alignContent: propValue
      });
    }
  }, {
    key: 'renderView',
    value: function renderView() {
      return this.props.children;
    }
  }]);

  return FlexLayout;
}(components_Layout);

FlexLayout.defaultProps = {};

dinamic_root_Dinamic_["registerView"]('FlexLayout', FlexLayout);
dinamic_root_Dinamic_["registerView"]('HFlexLayout', FlexLayout);

/* harmony default export */ var components_FlexLayout = (FlexLayout);
// CONCATENATED MODULE: ./src/components/GridLayout.jsx
var GridLayout_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function GridLayout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GridLayout_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function GridLayout_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * https://yuque.antfin-inc.com/dinamicx/document/gridlayout
 */

var GridLayout_GridLayout = function (_Layout) {
  GridLayout_inherits(GridLayout, _Layout);

  function GridLayout(props) {
    GridLayout_classCallCheck(this, GridLayout);

    var _this = GridLayout_possibleConstructorReturn(this, (GridLayout.__proto__ || Object.getPrototypeOf(GridLayout)).call(this, props));

    GridLayout_initialiseProps.call(_this);

    var columnCount = props.columnCount,
        itemWidth = props.itemWidth,
        itemHeight = props.itemHeight;

    if (!columnCount || !itemWidth || !itemHeight) {
      dinamic_root_Dinamic_["utils"].log.error('GridLayout 控件 columnCount/itemWidth/itemHeight 为必填属性');
      _this._error = false;
    }

    _this.setStyles({
      flexDirection: 'column'
    });
    return _this;
  }

  GridLayout_createClass(GridLayout, [{
    key: 'columnCount',
    value: function columnCount(propValue) {
      this._columnCount = propValue;
    }
  }, {
    key: 'itemWidth',
    value: function itemWidth(propValue) {
      this._itemWidth = dinamic_root_Dinamic_["unitParser"](propValue);
    }
  }, {
    key: 'rowCount',
    value: function rowCount(propValue) {}
  }, {
    key: 'rowSpacing',
    value: function rowSpacing(propValue) {
      this._rowSpacing = dinamic_root_Dinamic_["unitParser"](propValue);
    }
  }, {
    key: 'columnSpacing',
    value: function columnSpacing(propValue) {
      this._columnSpacing = dinamic_root_Dinamic_["unitParser"](propValue);
    }
  }, {
    key: 'lineColor',
    value: function lineColor(propValue) {
      this._lineColor = propValue;
    }
  }, {
    key: 'lineWidth',
    value: function lineWidth(propValue) {
      this._lineWidth = dinamic_root_Dinamic_["unitParser"](propValue);
    }
  }, {
    key: 'renderLoopChildren',


    // grid, flex-wrap 都有兼容性问题，这里自己计算换行
    value: function renderLoopChildren() {
      var _this2 = this;

      var subViews = [];
      var childrenViews = this.getChildren();
      var layoutProps = this.props;
      var rowCount = this._listData.length;

      // 所有子节点增加 subdata 缓存
      if (Array.isArray(this._listData)) {
        this._listData.map(function (rowData, rowIndex) {
          var rowStyle = {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            borderTop: rowIndex && _this2._borderStyle ? _this2._borderStyle : ''
          };
          // while (rowData.length < this._columnCount) {
          //   rowData.push({});
          // }

          var rowViews = rowData.map(function (columnData, columnIndex) {
            return childrenViews.map(function (sub) {
              var id = sub.props._id;
              var index = rowIndex * _this2._columnCount + columnIndex;
              var key = id + '-' + rowIndex + '-' + columnIndex;
              var itemStyle = {
                overflow: 'hidden',
                width: _this2._itemWidth,
                height: _this2._itemHeight,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginLeft: columnIndex && _this2._columnSpacing ? _this2._columnSpacing : 0,
                borderLeft: columnIndex && _this2._borderStyle ? _this2._borderStyle : '',
                marginTop: rowIndex && _this2._rowSpacing ? _this2._rowSpacing : 0
              };

              return dinamic_root_Dinamic_["h"](
                'div',
                { key: key, className: 'grid-item', style: itemStyle },
                loopMergeSubData.call(_this2, sub, columnData, index, layoutProps._id)
              );
            });
          });

          subViews.push(dinamic_root_Dinamic_["h"](
            'div',
            { key: 'gridrow' + rowIndex, className: 'grid-row', style: rowStyle },
            rowViews
          ));
        });
      }

      return subViews;
    }
  }, {
    key: 'renderView',
    value: function renderView() {
      return this._error ? null : this.renderLoopChildren();
    }
  }]);

  return GridLayout;
}(components_Layout);

var GridLayout_initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.itemHeight = function (propValue) {
    _this3._itemHeight = dinamic_root_Dinamic_["unitParser"](propValue);
  };

  this.needSeparator = ['lineColor', 'lineWidth', function (propValue) {
    _this3._needSeparator = _this3._lineColor && _this3._lineWidth && propValue === 'true';
    _this3._borderStyle = _this3._needSeparator ? _this3._lineWidth + ' solid ' + _this3._lineColor : '';
  }];
  this.listData = ['columnCount', function () {
    var listData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var columnCount = Number(_this3._columnCount);
    _this3._listData = [];

    for (var rowCount = 0; rowCount < listData.length / _this3._columnCount; rowCount++) {
      var startIndex = rowCount * columnCount;
      var endIndex = startIndex + columnCount;

      _this3._listData.push(listData.slice(startIndex, endIndex));
    }
  }];
};

GridLayout_GridLayout.defaultProps = {
  rowSpacing: 0,
  needSeparator: false,
  lineWidth: 0
};

dinamic_root_Dinamic_["registerView"]('GridLayout', GridLayout_GridLayout);

/* harmony default export */ var components_GridLayout = (GridLayout_GridLayout);
// CONCATENATED MODULE: ./src/components/ScrollerLayout.jsx
var ScrollerLayout_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ScrollerLayout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ScrollerLayout_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ScrollerLayout_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * https://yuque.antfin-inc.com/dinamicx/document/krm6bl
 */

var ScrollerLayout_ScrollerLayout = function (_Layout) {
  ScrollerLayout_inherits(ScrollerLayout, _Layout);

  function ScrollerLayout(props) {
    ScrollerLayout_classCallCheck(this, ScrollerLayout);

    var _this = ScrollerLayout_possibleConstructorReturn(this, (ScrollerLayout.__proto__ || Object.getPrototypeOf(ScrollerLayout)).call(this, props));

    _this.setStyles({
      overflow: 'auto'
    });
    return _this;
  }

  ScrollerLayout_createClass(ScrollerLayout, [{
    key: 'listData',
    value: function listData(_listData) {
      console.log(_listData);
      this._listData = _listData;
    }
  }, {
    key: 'paddingRight',
    value: function paddingRight(propValue) {
      this._paddingRight = dinamic_root_Dinamic_["unitParser"](propValue);
    }

    // 注意 ios8 上的兼容问题

  }, {
    key: 'renderLoopChildren',
    value: function renderLoopChildren() {
      var _this2 = this;

      var subViews = [];
      var childrenViews = this.getChildren();
      var layoutProps = this.props;

      var tempStyle = {};

      // 所有子节点增加 subdata 缓存
      if (Array.isArray(this._listData)) {
        this._listData.forEach(function (subdata, index) {
          childrenViews.forEach(function (sub) {
            var id = sub.props._id;

            subViews.push(dinamic_root_Dinamic_["h"](
              'div',
              { key: id + '-' + index, className: 'scroller-item', style: tempStyle },
              loopMergeSubData.call(_this2, sub, subdata, index, layoutProps._id)
            ));
          });
        });
      }

      if (this._paddingRight && subViews.length) {
        subViews.push(dinamic_root_Dinamic_["h"]('div', { style: { paddingRight: this._paddingRight } }));
      }

      return subViews;
    }
  }, {
    key: 'renderView',
    value: function renderView() {
      return this.renderLoopChildren();
    }
  }]);

  return ScrollerLayout;
}(components_Layout);

ScrollerLayout_ScrollerLayout.defaultProps = {
  rowSpacing: 0,
  needSeparator: false,
  lineWidth: 0
};

dinamic_root_Dinamic_["registerView"]('ScrollerLayout', ScrollerLayout_ScrollerLayout);

/* harmony default export */ var components_ScrollerLayout = (ScrollerLayout_ScrollerLayout);
// CONCATENATED MODULE: ./src/components/TextView.jsx
var TextView_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function TextView_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TextView_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TextView_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DEFAULT_LINE_HEIGHT = 1.2;

function charCodeTranslate(str) {
  var REG_CHAR_CODE = /&#(\d{1,5});/g;

  if (isString(str) && str.search(REG_CHAR_CODE) !== -1) {
    return str.replace(REG_CHAR_CODE, function (match, charCode) {
      return String.fromCharCode(charCode);
    });
  }

  return str;
}

var TextView_TextView = function (_View) {
  TextView_inherits(TextView, _View);

  function TextView() {
    var _ref;

    var _temp, _this, _ret;

    TextView_classCallCheck(this, TextView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = TextView_possibleConstructorReturn(this, (_ref = TextView.__proto__ || Object.getPrototypeOf(TextView)).call.apply(_ref, [this].concat(args))), _this), _this.textContent = null, _this.maxLines = ['textSize', 'lineSpace', 'lineHeight', function (propValue) {
      var maxLines = ~~propValue;
      var fontSize = parseFloat(this.fontSize);

      var tempStyle = {
        whiteSpace: 'pre-wrap'
      };

      if (maxLines > 1) {
        var lineHeight = numTrunc((fontSize + parseFloat(this._lineSpace)) * DEFAULT_LINE_HEIGHT);
        if (this._lineHeight) {
          lineHeight = numTrunc(parseFloat(this._lineHeight) + parseFloat(this._lineSpace));
        }

        tempStyle = {
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: '' + maxLines,
          lineHeight: lineHeight + 'px',
          overflow: 'hidden'
        };
      } else {
        tempStyle.lineHeight = this._lineHeight || numTrunc(fontSize * DEFAULT_LINE_HEIGHT) + 'px';

        if (maxLines !== 0) {
          tempStyle.whiteSpace = 'nowrap';
        }
      }

      this.setStyles({
        overflow: 'hidden'
      });
      this.setStyles(tempStyle, 'font');
    }], _this.textAlignment = ['textGravity', _this.textGravity], _temp), TextView_possibleConstructorReturn(_this, _ret);
  }

  TextView_createClass(TextView, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {

      // 文字更新后，尝试重计算
      this.calcLayoutSize();
    }

    // 最大行数，默认1

  }, {
    key: 'lineHeight',
    value: function lineHeight(propValue) {
      if (propValue == -1) {
        this._lineHeight = 0;
      } else {
        this._lineHeight = dinamic_root_Dinamic_["unitParser"](propValue);
      }
    }

    // 文本内容，默认空
    // 注意不能改为数组，否则继承 textview 的 textinput 等组件会受影响，无法覆盖 text 方法

  }, {
    key: 'text',
    value: function text(propValue, curProps) {
      var _ref2 = curProps || this.props,
          visibility = _ref2.visibility;

      if (visibility === 'gone' || visibility === 'invisible') {
        return;
      }

      if (propValue) {
        this.textContent = propValue;
        this.setStyles({
          display: 'flex'
        });
      } else {
        this.setStyles({
          display: 'none'
        });
      }
    }
  }, {
    key: 'textSize',
    value: function textSize(propValue) {
      var fontSize = dinamic_root_Dinamic_["unitParser"](propValue);
      this.setStyles({ fontSize: fontSize });
      this.fontSize = fontSize;
    }
  }, {
    key: 'lineSpace',
    value: function lineSpace(propValue) {
      this._lineSpace = dinamic_root_Dinamic_["unitParser"](propValue) || 0;
    }

    // 文字样式，normal, bold, italic

  }, {
    key: 'textStyle',
    value: function textStyle(propValue) {
      var tempStyle = {};

      switch (propValue) {
        case 'bold':
          tempStyle.fontWeight = 'bold';
          break;
        case 'italic':
          tempStyle.fontStyle = 'italic';
          break;
        default:
          break;
      }

      this.setStyles(tempStyle);
    }

    // 文本颜色，默认黑色，#FF000000

  }, {
    key: 'textColor',
    value: function textColor(propValue) {
      this.setStyles({
        color: dinamic_root_Dinamic_["colorParser"](propValue)
      });
    }

    // 对齐方式，默认垂直方向都居中，水平方向可选；left, center, right

  }, {
    key: 'textGravity',
    value: function textGravity(propValue) {
      var justifyContent = 'center';
      switch (propValue) {
        case 'left':
          justifyContent = 'flex-start';
          break;
        case 'right':
          justifyContent = 'flex-end';
      }

      this.setStyles({
        justifyContent: justifyContent,
        alignItems: 'center'
      });
    }
    // 兼容老版本名称

  }, {
    key: 'lineBreakMode',


    // 换行方式,
    // end: abc…
    // none: xyz
    // start: …xyz
    // middle: ab…yz
    value: function lineBreakMode(propValue) {
      var tempStyle = {
        overflow: 'hidden'
      };
      switch (propValue) {
        case 'none':
          // 内层裁切，外层需要限定超出之后隐藏
          this.setStyles({ overflow: 'hidden' });

          tempStyle.textOverflow = 'clip';
          break;
        case 'start':
        case 'middle':
          // not support
          break;
        case 'end':
          tempStyle.textOverflow = 'ellipsis';
      }

      this.setStyles(tempStyle, 'font');
    }

    // 在width设为"match_content"的情况下，限制其最大宽度。默认是-1，即没有限制。

  }, {
    key: 'maxWidth',
    value: function maxWidth(propValue) {
      this.setStyles({
        maxWidth: propValue === '-1' ? 'none' : dinamic_root_Dinamic_["unitParser"](propValue)
      });
    }
  }, {
    key: 'isBold',
    value: function isBold(propValue) {
      if (propValue) {
        this.setStyles({ fontWeight: 'bold' });
      }
    }
  }, {
    key: 'isItalic',
    value: function isItalic(propValue) {
      if (propValue) {
        this.setStyles({ fontStyle: 'italic' });
      }
    }
  }, {
    key: 'isStrikeThrough',
    value: function isStrikeThrough(propValue) {
      if (propValue) {
        this.setStyles({ textDecoration: 'line-through' });
      }
    }
  }, {
    key: 'strikeThroughStyle',
    value: function strikeThroughStyle(propValue) {
      if (propValue === 'single') {
        this.setStyles({ textDecoration: 'line-through' });
      }
    }
  }, {
    key: 'isUnderline',
    value: function isUnderline(propValue) {
      if (propValue) {
        this.setStyles({ textDecoration: 'underline' });
      }
    }
  }, {
    key: 'renderView',
    value: function renderView() {
      return dinamic_root_Dinamic_["h"](
        'span',
        { style: this.getStyles('font') },
        charCodeTranslate(this.textContent)
      );
    }
  }]);

  return TextView;
}(components_View);

TextView_TextView.defaultProps = {
  textSize: '12np',
  textGravity: 'left',
  lineBreakMode: 'end',
  maxLines: '1',
  maxWidth: '-1',
  lineHeight: '-1'
};

dinamic_root_Dinamic_["registerView"]('TextView', TextView_TextView);
dinamic_root_Dinamic_["registerView"]('DTextView', TextView_TextView);
dinamic_root_Dinamic_["registerView"]('FastTextView', TextView_TextView);

/* harmony default export */ var components_TextView = (TextView_TextView);
// CONCATENATED MODULE: ./src/utils/isSupportWebp.js


var storage = window.localStorage;
var isSupportWebp = function isSupportWebp() {
  // 1. 检查 全局
  if (window.DXSUPPORTWEBP !== undefined) {
    return window.DXSUPPORTWEBP;
  }
  // 检查 localstorage并保存全局
  var isSupport = storage.getItem('dx-isSupportWebp');
  if (isSupport === 'true') {
    window.DXSUPPORTWEBP = isSupport === 'true';
    return window.DXSUPPORTWEBP;
  }
  // 通过方法判断是否支持
  var result = document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0;

  storage.setItem('dx-isSupportWebp', result ? 'true' : 'false');
  window.DXSUPPORTWEBP = result;

  return result;
};

/* harmony default export */ var utils_isSupportWebp = (isSupportWebp);
// CONCATENATED MODULE: ./src/components/ImageView.jsx
var ImageView_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ImageView_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ImageView_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ImageView_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var REG_IS_URL = /^(http)?(s)?(:)?\/\//;
// const REG_PIC_SIZE = /_\d+x\d+/;
var REG_PIC_DOMAIN = /(gw|img)\.alicdn\.com/;
var REG_PIC_EXT = /(\.gif)$/;

var SQUARE = [16, 20, 24, 30, 32, 36, 40, 48, 50, 60, 64, 70, 72, 80, 88, 90, 100, 110, 120, 125, 128, 145, 180, 190, 200, 200, 210, 220, 230, 240, 250, 270, 300, 310, 315, 320, 336, 360, 468, 490, 540, 560, 580, 600, 640, 720, 728, 760, 970];

var ImageView_isSupportWebp = utils_isSupportWebp();
// document
//   .createElement('canvas')
//   .toDataURL('image/webp')
//   .indexOf('data:image/webp') == 0;
// const isSupportWebp = (()=>{
//  1. 检查当前localstorage里是否有
// })()


// const LARGE_IMG_PX = 400 * 400;


// 图片加载后，刷新模版的队列
// 由于图片异步加载，所以如果最开始未加载成功的情况下会导致拿不到尺寸，所以需要在加载完成后，重刷一次模版（单模版仅在onload时重刷一次）
var IMG_REFRESH_QUEUE = [];

function getImageClipParam(width, height) {
  var widthNum = parseInt(width) || -1;
  var heightNum = parseInt(height) || -1;
  var isAllNum = widthNum !== -1 && heightNum !== -1;

  // 默认规则，620宽 + 适高
  var size = '_620x10000';

  // 降质，对于图像大于400的图片质量降低到90%
  var webp = ImageView_isSupportWebp ? '_.webp' : '';
  var q = 'q90';

  if (isAllNum) {
    var fixSize = Math.max(widthNum, heightNum) * 2;
    var imgPX = widthNum * heightNum;
    for (var i = 0, len = SQUARE.length; i < len; i++) {
      if (SQUARE[i] > fixSize) {
        var s = SQUARE[i];
        size = '_' + s + 'x' + s;
        break;
      }
    }

    // if (imgPX > LARGE_IMG_PX) {
    // }
  }

  return size + q + webp;
}

var ImageView_ImageView = function (_View) {
  ImageView_inherits(ImageView, _View);

  function ImageView(props) {
    ImageView_classCallCheck(this, ImageView);

    var _this = ImageView_possibleConstructorReturn(this, (ImageView.__proto__ || Object.getPrototypeOf(ImageView)).call(this, props));

    _this.setStyles({
      width: '100%',
      height: '100%'
    }, 'img');

    _this.setStyles({
      overflow: 'hidden'
    });

    _this.imageData = {};
    return _this;
  }

  ImageView_createClass(ImageView, [{
    key: 'imageName',
    value: function imageName(name) {
      this.setStyles({
        backgroundImage: 'url(' + dinamic_root_Dinamic_["getLocalImage"](name) + ')'
      }, 'img');
    }
  }, {
    key: 'image',
    value: function image(img) {
      if (REG_IS_URL.test(img)) {
        this.setStyles({
          backgroundImage: 'url(' + img + ')'
        }, 'img');
      } else {
        this.setStyles({
          background: img
        }, 'img');
      }
    }
  }, {
    key: 'imageUrl',
    value: function imageUrl() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _props = this.props,
          width = _props.width,
          height = _props.height,
          aspectRatio = _props.aspectRatio;
      // 图片使用适宽或者适高单位，宽高比未定义，使用图片原始宽高比，在dynamicImageLoaded时计算尺寸

      if (width === 'match_content' && aspectRatio === undefined || height === 'match_content' && aspectRatio === undefined) {
        this.imageData = {
          isAutoImg: true,
          imgSrc: value,
          fallbackSrc: value
        };
      } else {
        // 固定宽/高的情况下，图片缩放裁切、降质
        var size = '';
        var originSrc = '';

        if (value && REG_PIC_DOMAIN.test(value) && !REG_PIC_EXT.test(value)) {
          // 对于下发的图片中包含 _200x200.jpg 等优化过尺寸的图片，取到原始地址使用新的优化
          originSrc = value.replace(/_\d+x\d+\.(jpg|png|gif|jpeg)$/i, '');
          size = getImageClipParam(width, height);
        }
        this.imageData = {
          isAutoImg: false,
          imgSrc: (originSrc || value) + size,
          fallbackSrc: value
        };

        if (aspectRatio) {
          var tempStyle = {};
          var widthStr = String(width);
          var heightStr = String(height);
          var matchPattern = /match_/;

          if (matchPattern.test(widthStr) && height && !matchPattern.test(heightStr)) {
            var heightNum = parseFloat(dinamic_root_Dinamic_["unitParser"](heightStr));
            tempStyle.width = heightNum * aspectRatio + 'px';
          } else if (matchPattern.test(heightStr) && widthStr && !matchPattern.test(widthStr)) {
            var widthNum = parseFloat(dinamic_root_Dinamic_["unitParser"](widthStr));
            tempStyle.height = widthNum * aspectRatio + 'px';
          }

          this.setStyles(tempStyle, 'img');
        }
      }
    }
  }, {
    key: 'aspectRatio',
    value: function aspectRatio(value) {
      this.aspectRatioValue = value;
    }
  }, {
    key: 'scaleType',
    value: function scaleType(value) {
      var tempStyle = {};
      // fitXY或fitCenter或centerCrop
      tempStyle.backgroundRepeat = 'no-repeat';
      tempStyle.backgroundPosition = 'center';
      switch (value) {
        case 'fitXY':
          tempStyle.backgroundSize = '100% 100%';
          break;
        case 'fitCenter':
        case 'centerInside':
          tempStyle.backgroundSize = 'contain';
          break;
        case 'centerCrop':
          tempStyle.backgroundSize = 'cover';
      }

      this.setStyles(tempStyle, 'img');
    }
  }, {
    key: 'dynamicImageLoaded',
    value: function dynamicImageLoaded() {
      var _imageData = this.imageData,
          imgSrc = _imageData.imgSrc,
          isAutoImg = _imageData.isAutoImg;

      var wrapEl = this.$wrap;
      // 图片异步加载 ，包含适宽或者适高情况
      if (isAutoImg && wrapEl) {
        var _ref = this.$img || {},
            _ref$naturalHeight = _ref.naturalHeight,
            naturalHeight = _ref$naturalHeight === undefined ? null : _ref$naturalHeight,
            _ref$naturalWidth = _ref.naturalWidth,
            naturalWidth = _ref$naturalWidth === undefined ? null : _ref$naturalWidth;

        var _props2 = this.props,
            width = _props2.width,
            height = _props2.height;

        var aspectRatio = null;
        if (naturalHeight && naturalWidth) {
          aspectRatio = this.aspectRatioValue || naturalWidth / naturalHeight;
        }
        // 图片加载失败时可能会出现，但是还有不明原因的ref找不到元素的情况，待查
        if (!aspectRatio) return;
        // 适宽，适高，使用原始尺寸即可
        if (width === 'match_content' && height === 'match_content') {
          wrapEl.style.height = naturalHeight;
          wrapEl.style.width = naturalWidth;
        }
        // 定宽 适高
        if (height === 'match_content' && width !== 'match_content') {
          // 针对宽度 match_parent的特殊处理
          var parentWidth = wrapEl.parentElement.offsetWidth;
          wrapEl.style.height = Math.ceil(parseFloat(width === 'match_parent' ? parentWidth : width) * (1 / aspectRatio)) + 'px';
        }
        // 定高 适宽
        if (width === 'match_content' && height !== 'match_content') {
          // 针对高度 match_parent 的特殊处理
          var parentHeight = wrapEl.parentElement.offsetHeight;
          wrapEl.style.width = Math.ceil(aspectRatio * parseFloat(height === 'match_parent' ? parentHeight : height)) + 'px';
        }

        // 设置尺寸，重计算
        this.calcLayoutSize();
      }
      if (wrapEl) wrapEl.style.backgroundImage = 'url(' + imgSrc + ')';
    }
  }, {
    key: 'dynamicImageLoadError',
    value: function dynamicImageLoadError() {
      var fallbackSrc = this.imageData.fallbackSrc;
      var _props3 = this.props,
          width = _props3.width,
          height = _props3.height;

      if (width === 'match_parent' && height === 'match_parent') {
        var wrapHeight = ~~this.$wrap.offsetHeight;
        var wrapWidth = ~~this.$wrap.offsetWidth;
        fallbackSrc += getImageClipParam(wrapWidth, wrapHeight);
      }

      if (fallbackSrc && this.$wrap) this.$wrap.style.backgroundImage = 'url(' + fallbackSrc + ')';
    }
  }, {
    key: 'renderView',
    value: function renderView() {
      var _this2 = this;

      var _ref2 = this.imageData || {},
          imgSrc = _ref2.imgSrc;
      // 这里会对宽高均适配父层的情况做特殊处理，走loaderror的方式再次


      var _props4 = this.props,
          width = _props4.width,
          height = _props4.height;
      // 要注意处理解析表达式结果为 'undefined' 的情况

      if (imgSrc && imgSrc !== 'undefined') {
        return dinamic_root_Dinamic_["h"](
          'div',
          { ref: function ref($wrap) {
              return _this2.$wrap = $wrap;
            }, style: this.getStyles('img') },
          dinamic_root_Dinamic_["h"]('img', {
            onLoad: function onLoad() {
              return _this2.dynamicImageLoaded();
            },
            onError: function onError() {
              return _this2.dynamicImageLoadError();
            },
            src: width === 'match_parent' && height === 'match_parent' ? '' : imgSrc,
            ref: function ref($img) {
              return _this2.$img = $img;
            },
            style: {
              maxHeight: '100%',
              maxWidth: '100%',
              opacity: 0
            }
          })
        );
      }

      return dinamic_root_Dinamic_["h"]('div', { style: this.getStyles('img') });
    }
  }]);

  return ImageView;
}(components_View);

ImageView_ImageView.defaultProps = {
  scaleType: 'fitCenter'
};

dinamic_root_Dinamic_["registerView"]('ImageView', ImageView_ImageView);
dinamic_root_Dinamic_["registerView"]('DImageView', ImageView_ImageView);

/* harmony default export */ var components_ImageView = (ImageView_ImageView);
// CONCATENATED MODULE: ./src/components/TImageView.jsx
var TImageView_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function TImageView_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TImageView_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TImageView_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx Dinamic.h */




var TImageView = function (_ImageView) {
  TImageView_inherits(TImageView, _ImageView);

  function TImageView() {
    TImageView_classCallCheck(this, TImageView);

    return TImageView_possibleConstructorReturn(this, (TImageView.__proto__ || Object.getPrototypeOf(TImageView)).apply(this, arguments));
  }

  TImageView_createClass(TImageView, [{
    key: 'tImage',
    value: function tImage(propValue) {
      this.image(propValue);
    }
  }, {
    key: 'tImageUrl',
    value: function tImageUrl(propValue) {
      this.imageUrl(propValue);
    }
  }, {
    key: 'tLocalImageName',
    value: function tLocalImageName(propValue) {
      this.imageName(propValue);
    }
  }, {
    key: 'tScaleType',
    value: function tScaleType(propValue) {
      this.scaleType(propValue);
    }
  }]);

  return TImageView;
}(components_ImageView);

TImageView.defaultProps = {
  tScaleType: 'fitCenter'
};

dinamic_root_Dinamic_["registerView"]('TImageView', TImageView);

/* harmony default export */ var components_TImageView = (TImageView);
// CONCATENATED MODULE: ./src/components/HImageView.jsx
var HImageView_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HImageView_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HImageView_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HImageView_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var HImageView = function (_ImageView) {
  HImageView_inherits(HImageView, _ImageView);

  function HImageView() {
    HImageView_classCallCheck(this, HImageView);

    return HImageView_possibleConstructorReturn(this, (HImageView.__proto__ || Object.getPrototypeOf(HImageView)).apply(this, arguments));
  }

  HImageView_createClass(HImageView, [{
    key: 'hImageUrl',
    value: function hImageUrl(propValue) {
      this.imageUrl(propValue);
    }
  }, {
    key: 'hPlaceHolderImage',
    value: function hPlaceHolderImage(propValue) {
      this.placeHolderImage(propValue);
    }
  }, {
    key: 'hAspectRatio',
    value: function hAspectRatio(propValue) {
      this.aspectRatio(propValue);
    }
  }, {
    key: 'hCornerRadius',
    value: function hCornerRadius(propValue) {
      this.cornerRadius(propValue);
    }
  }, {
    key: 'hBorderWidth',
    value: function hBorderWidth(propValue) {
      this.borderWidth(propValue);
    }
  }, {
    key: 'hBorderColor',
    value: function hBorderColor(propValue) {
      this.borderColor(propValue);
    }
  }, {
    key: 'hScaleType',
    value: function hScaleType(propValue) {
      this.scaleType(propValue);
    }
  }]);

  return HImageView;
}(components_ImageView);

HImageView.defaultProps = {
  hScaleType: 'fitCenter'
};

dinamic_root_Dinamic_["registerView"]('HImageView', HImageView);

/* harmony default export */ var components_HImageView = (HImageView);
// CONCATENATED MODULE: ./src/components/HGifView.jsx
var HGifView_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HGifView_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HGifView_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HGifView_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var HGifView = function (_HImageView) {
  HGifView_inherits(HGifView, _HImageView);

  function HGifView() {
    HGifView_classCallCheck(this, HGifView);

    return HGifView_possibleConstructorReturn(this, (HGifView.__proto__ || Object.getPrototypeOf(HGifView)).apply(this, arguments));
  }

  HGifView_createClass(HGifView, [{
    key: 'hGifUrl',
    value: function hGifUrl(value) {
      if (value) {
        this.setStyles({
          backgroundImage: 'url(' + value + ')'
        }, 'img');
      }
    }
  }]);

  return HGifView;
}(components_HImageView);

dinamic_root_Dinamic_["registerView"]('HGifView', HGifView);

/* harmony default export */ var components_HGifView = (HGifView);
// CONCATENATED MODULE: ./src/components/HVideoView.jsx
var HVideoView_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HVideoView_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HVideoView_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HVideoView_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var HVideoView = function (_HImageView) {
  HVideoView_inherits(HVideoView, _HImageView);

  function HVideoView() {
    HVideoView_classCallCheck(this, HVideoView);

    return HVideoView_possibleConstructorReturn(this, (HVideoView.__proto__ || Object.getPrototypeOf(HVideoView)).apply(this, arguments));
  }

  HVideoView_createClass(HVideoView, [{
    key: 'hCoverURL',
    value: function hCoverURL(value) {
      var _props = this.props,
          width = _props.width,
          height = _props.height;


      if (width === 'match_content' || height === 'match_content') {
        this.isAutoImg = true;
        this.imgSrc = value;
      }

      if (value) {
        this.setStyles({
          backgroundImage: 'url(' + value + ')'
        });
      }
    }
  }, {
    key: 'coverUrl',
    value: function coverUrl(value) {
      this.imageUrl(value);
    }
  }]);

  return HVideoView;
}(components_HImageView);

dinamic_root_Dinamic_["registerView"]('HVideoView', HVideoView);

/* harmony default export */ var components_HVideoView = (HVideoView);
// CONCATENATED MODULE: ./src/components/Switch.jsx
var Switch_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Switch_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Switch_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Switch_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Switch_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Switch_Switch = function (_View) {
  Switch_inherits(Switch, _View);

  function Switch() {
    var _ref;

    var _temp, _this, _ret;

    Switch_classCallCheck(this, Switch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Switch_possibleConstructorReturn(this, (_ref = Switch.__proto__ || Object.getPrototypeOf(Switch)).call.apply(_ref, [this].concat(args))), _this), _this._checked = false, _this._enabled = true, _this.switchOn = ['onColor', 'offColor', function (propValue) {
      // 此处统一处理onColor, offColor, 不再为该2个函数单独设置 set 函数
      // switch的颜色 依赖于 dSwitchOn 选中状态
      var checked = toLikeBoolean(propValue);

      this.setStyles({
        backgroundColor: checked ? this._onColor : this._offColor
      });

      this._checked = checked;
    }], _this.enabled = ['switchOn', function (propValue) {
      var enabled = toLikeBoolean(propValue);

      if (!enabled) {
        _this.setStyles({
          backgroundColor: '#ccc'
        });
      }

      _this._enabled = enabled;
    }], _this.toggleCheck = function () {
      var checked = !_this._checked;
      _this.setStyles({ backgroundColor: checked ? _this._onColor : _this._offColor });

      var callback = _this.getEvents('switch').onChange;
      callback && callback.handler({ value: checked });
    }, _temp), Switch_possibleConstructorReturn(_this, _ret);
  }

  Switch_createClass(Switch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var target = this.$switch;
      // 扩大事件响应区域
      if (this.$switch && this.$switch.parentNode) {
        target = this.$switch.parentNode;
      }

      // 事件绑定
      utils_bindGestureEvent(target, {
        tap: function tap() {
          _this2._enabled && _this2.toggleCheck();
        }
      });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._preprocessingStyle();
    }
  }, {
    key: '_preprocessingStyle',
    value: function _preprocessingStyle() {
      // 外部容器带有border, 取height值作为borderRadius
      // 内部小圆距离外部有 1px 的距离，此处单独处理一下
      var height = this.props.height;

      var size = dinamic_root_Dinamic_["unitParser"](height);
      var switchHW = size.replace(/(\d*)/, function (number) {
        return number - 2;
      });
      this.setStyles({ borderRadius: size });

      this.setStyles(Switch_extends({}, DefaultStyle, {
        width: switchHW,
        height: switchHW
      }), 'switch');

      this.setStyles({
        left: '1px'
      }, 'switchNormal');

      this.setStyles({
        right: '1px'
      }, 'switchActive');

      this.setStyles({
        boxShadow: 'inset 0 0 0 1px #ccc'
      });
    }
  }, {
    key: 'onColor',


    // hack: h5当前判断事件依赖 on开头，但是这个是一个个例
    value: function onColor(propValue) {
      this._onColor = dinamic_root_Dinamic_["colorParser"](propValue);
    }
  }, {
    key: 'offColor',
    value: function offColor(propValue) {
      this._offColor = dinamic_root_Dinamic_["colorParser"](propValue);
    }
  }, {
    key: 'onChange',
    value: function onChange(propValue) {
      this.setEvents({
        onChange: propValue
      }, 'switch');
    }
  }, {
    key: 'renderView',
    value: function renderView() {
      var _this3 = this;

      return dinamic_root_Dinamic_["h"]('div', {
        style: Switch_extends({}, this.getStyles('switch'), this.getStyles(this._checked ? 'switchActive' : 'switchNormal')),
        ref: function ref($switch) {
          return _this3.$switch = $switch;
        }
      });
    }
  }]);

  return Switch;
}(components_View);

var DefaultStyle = {
  position: 'absolute',
  top: '1px',
  borderRadius: '50%',
  backgroundColor: '#FFFFFF',
  boxShadow: '0px 2px 5px 1px #ccc'
};

Switch_Switch.defaultProps = {
  width: '25np',
  height: '12.5np',
  onColor: '#ff5000',
  offColor: '#FFFFFF',
  switchOn: 0
};

dinamic_root_Dinamic_["registerView"]('Switch', Switch_Switch);
dinamic_root_Dinamic_["registerView"]('DSwitch', Switch_Switch);

/* harmony default export */ var components_Switch = (Switch_Switch);
// CONCATENATED MODULE: ./src/components/CheckBox.jsx
var CheckBox_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function CheckBox_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CheckBox_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CheckBox_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var REG_ISNOT_DEFAUTL_IMAGE = /^((http(s)?)|(data:image))/;
var DINAMICX_CHECKED = 'dinamicx_checked';
var DINAMICX_DISCHECK = 'dinamicx_discheck';
var DINAMICX_UNCHECK = 'dinamicx_uncheck';
var DINAMICX_DISUNCHK = 'dinamicx_disunchk';

var CheckBox_validateImage = function validateImage(name, defaultName) {
  // 本来就是传递的url，或者base64
  if (REG_ISNOT_DEFAUTL_IMAGE.test(name)) {
    return name;
  }
  var localImage = dinamic_root_Dinamic_["getLocalImage"](name);
  // 'test_icon' 当本没有对应图片时，取默认值
  return localImage ? localImage : dinamic_root_Dinamic_["getLocalImage"](defaultName);
};

var CheckBox_CheckBox = function (_View) {
  CheckBox_inherits(CheckBox, _View);

  function CheckBox() {
    var _ref;

    var _temp, _this, _ret;

    CheckBox_classCallCheck(this, CheckBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = CheckBox_possibleConstructorReturn(this, (_ref = CheckBox.__proto__ || Object.getPrototypeOf(CheckBox)).call.apply(_ref, [this].concat(args))), _this), _this._enabled = true, _this._checked = false, _this._selfChecked = null, _this.toggleCheck = function () {
      _this._selfChecked = !_this._checked;

      _this.forceUpdate();

      var callback = _this.getEvents('checkbox').onChange;
      callback && callback.handler({ value: _this._selfChecked });
    }, _temp), CheckBox_possibleConstructorReturn(_this, _ret);
  }

  CheckBox_createClass(CheckBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // 事件绑定
      utils_bindGestureEvent(this.$checkbox, {
        tap: function tap() {
          _this2._enabled && _this2.toggleCheck();
        }
      });
    }
  }, {
    key: '_updateImages',
    value: function _updateImages() {
      this.setStyles({ borderRadius: '50%', width: '100%', height: '100%' }, 'checkbox');
      var _checked = this._checked,
          _enabled = this._enabled;

      var imageKey = _checked ? 'checked' : 'unchecked';
      var imageUrl = this['_' + (_enabled ? '' : 'dis') + imageKey + 'Img'];
      this.setStyles({ background: 'url(' + imageUrl + ') 0% 0% / 100% 100%' }, 'checkbox');
    }
  }, {
    key: 'enabled',
    value: function enabled(propValue) {
      this._enabled = toLikeBoolean(propValue);
    }
  }, {
    key: 'checked',
    value: function checked(propValue) {
      var _selfChecked = this._selfChecked;


      if (_selfChecked !== null) {
        this._checked = _selfChecked;

        this._selfChecked = null;
      } else {
        this._checked = toLikeBoolean(propValue);
      }
    }
  }, {
    key: 'checkImg',
    value: function checkImg(propValue) {
      this._checkedImg = CheckBox_validateImage(propValue, DINAMICX_CHECKED);
    }
  }, {
    key: 'disCheckImg',
    value: function disCheckImg(propValue) {
      this._discheckedImg = CheckBox_validateImage(propValue, DINAMICX_DISCHECK);
    }
  }, {
    key: 'uncheckImg',
    value: function uncheckImg(propValue) {
      this._uncheckedImg = CheckBox_validateImage(propValue, DINAMICX_UNCHECK);
    }
  }, {
    key: 'disUncheckImg',
    value: function disUncheckImg(propValue) {
      this._disuncheckedImg = CheckBox_validateImage(propValue, DINAMICX_DISUNCHK);
    }
  }, {
    key: 'onChange',
    value: function onChange(propValue) {
      this.setEvents({
        onChange: propValue
      }, 'checkbox');
    }
  }, {
    key: 'renderView',
    value: function renderView() {
      var _this3 = this;

      // 该函数进行渲染前的选中、非选中图片替换
      this._updateImages();

      return dinamic_root_Dinamic_["h"]('div', {
        style: this.getStyles('checkbox'),
        ref: function ref($checkbox) {
          return _this3.$checkbox = $checkbox;
        }
      });
    }
  }]);

  return CheckBox;
}(components_View);

CheckBox_CheckBox.defaultProps = {
  enabled: 1,
  checked: 0,
  checkImg: DINAMICX_CHECKED,
  disCheckImg: DINAMICX_DISCHECK,
  uncheckImg: DINAMICX_UNCHECK,
  disUncheckImg: DINAMICX_DISUNCHK
};

// 设置checkbox 默认图片
var Images = {
  dinamicx_checked: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABEBAMAAADKPY6BAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAFZaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA1LjQuMCI+CiAgIDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICAgICAgICAgIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj4KICAgICAgICAgPHRpZmY6T3JpZW50YXRpb24+MTwvdGlmZjpPcmllbnRhdGlvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+CkzCJ1kAAAAqUExURUdwTP9rAP9xAP9vAP9pAP9tAP9rAP9tAP9fAP90AP9XAP99AP9nAP9tACJieToAAAAIdFJOUwCH6CSqRmbMw7TcXwAAAy1JREFUSMd1lr+LE0EUxzdeFMuAdnfCgYIecqAiIlwTPQRBhHioaHd4ZRrxKrlOPBlCqhM8hmWLmJAsU1oIy1RayBax0EYC2f/F92tmZ5Lc1o/PfN+b73zfJkn43bv8bvvn9QcHyVnf+YdVVf2eTqfltc7qittbWQY1UDJVHy6tqniutRbKtK/Uo+WKu1Axm1XVfA4HlUqp3cWKRgoleA4d1AdM3oor1t4XGjFOL2Imt6KSvaKQijnJxc8chxUXbKGhJhNKSZRevh+UrBdIybSj9LFCmUGg1VqtQy0KKaZnasVdW1jXEVFEjBn7wVubotoMp+vnghTjLuKOhRqk6GguKjdmKCVH1lLPuvJzcZSJF+tr3Fy4Bj4WvIPn6FQa4rk4ipz0BCHUNY6OKFhDWsxI+oFPc0tLFOqpSVJsGkwu0GLaIiWYLs6FOuoxBcWse0oW+UWRFhJzs9aio5tminFquaPYL6wF9JJaOKbQtV8A8/HljV5P9J6zjElDvyi1n7xiLWZTGiqKWMunJLnIEGipa+WkyC9gyfs9poy5Z/BLEfrlF3T6WLQM6IbwoMgvAGkqOWiEZvEHOb8IhGsmMrki8ksLITJd81VKbOiXHwjx0zWJQEK/MCSX6UoJUE4O3vA9OkhNES32e7K2xfkiSpwW47V8hsdCfiFI6f0CHR0J5QskyDbKRUg/uOmJjM7qb5Ame0D5A5CN0C8jfwHpVfBORpCG+CWXC+i60Z0A5jVD6AnIcOEad8QvujgEDEMiylAsha47BcwzgQRaNsWYNN1DfuLukUhHbbE3hccplWzUWSf2duPFO3orEMo6d0fuqaUUQYi54nOXtQz8g6U3AphG8I5y92CbNWX278XTxdfYduHBposSU7R0XARxTZ0vfUcZ+SDjxJwF+0i0DH0cpgv54v3S8qFq43zxyTCpo5nlLufLMAz4aB+VTkunXhOcddE+Qr+Mg2XDWafjlAqXDdxTvI8oDk24smDxxfuI/RItvmTPxvuIao4XlnC8j9TyEk4a8T5CSmvVD0HU0e7K34p6H5Wrfivo58Tvo9U/J/KLQ1rO+sWRH6W/iz9K/wEP1oz20WaXfgAAAABJRU5ErkJggg==',
  dinamicx_discheck: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA5BAMAAAB+Np62AAAAIVBMVEVHcEzNzc3Nzc3Nzc3Nzc3Nzc3T09PNzc3Pz8/Nzc3MzMz103I3AAAACnRSTlMAz1LsjLEVZyI/uIMIOwAAAVdJREFUOMuFlTFPw0AMha9RVdKtA2K4CSTE0KnA1EydOxXB1KmdKjF1YMpUqbB3ZiKkSMW/kgvNOXdnn89Lm3x6iWM/+5TCGNw+Pdb3L3eKi3cN57jcUXgDGNW1ACn+AC9+vIcPC5/C1KUlhLHtYJ9AOHZ0SSksBKkjLjlq3zxkIfye6Z6n9S6aE+aVRSB8N7QXo1VDxzEKTS90lI6UyqMQTpFCYbmYpKq3wqb1yr2vre2KSdlIPm3Scy7V9uaM1tFIL7CWmpGW+LeIS2FC6JXjhomykuf2d9VJ4ctqFwNNpN2Tt2pNpIZq+2n/Yk9qcl6iEdah1HzvHFudF43UrewMr4x4b6SZbw7s0UHlgdT0qOcNZRaUDb1RH0ILHl1fTUNvn1xPGvE47JZz52FD/SzPgjxH8gwm5leefXlvJHaOvK8Su07ek4kdK+/nxG5PnAuJM4U9j/4A+2ARe5cQ9TAAAAAASUVORK5CYII=',
  dinamicx_uncheck: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAMAAAAPzWOAAAAANlBMVEVHcEzMzMzNzc3V1dXOzs7Nzc3Nzc3Nzc3Nzc3Nzc3b29vMzMz////19fXu7u7a2trk5OTR0dG06x/LAAAAC3RSTlMAN84GVqG36X8jB0no5zwAAAGJSURBVFjDrVjZtoQgDFOEqUvZ/v9nRwGvy1UHMHmdMadNWmhpmlsMsleCaJqIhOrl0JRilGr++ghSciygaP8zrDxtLsVnesAnh2bYKKwzWvMMrY2zG80vdbo+/dO78Pke2vn0Y989hiFSDIYvYVI84iEYGfW0mm+hIw3JO46Yijf8CBOT6p84LP+EvWeJHI4z4O5YIofhLJhrFhnk0JwJHYQ5qTsEX7I5Zpbg0cHpThTksstIdGdBHBfBnWQZMr29cHpLaOk5z8VYxP389X6xIDtZ2l0glitgt1DaQndPPsdQVG0gMRQVzmSqU2RVhcZU8J4r4VPxq/I6O1bckg/VyrpKS6lauRqxamW9N6s/MvSeqydxoQtVvcGryaoRb3SNyop35qz20Ctzgj3UTO9JJgwJJB2IsBCLIcUGKXtIA0KOAsihhDkeIQc15MqAXF6YaxRyoWNGC8iQgxm3IIMfZgSFDMOYsRyzIGBWFczShFnfMIskZqXFLNeYNR/04AB6+gA9wpQ+B30B3RGo3Y8v7Z8AAAAASUVORK5CYII=',
  dinamicx_disunchk: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA5BAMAAAB+Np62AAAAJFBMVEVHcEzNzc3Ozs7Ozs7Nzc3Nzc3Nzc3Ozs7MzMzx8fHa2trr6+ssMFmhAAAACHRSTlMA0kwgje2zY5e6RVIAAAFESURBVDjLhZW/TsMwEMZNygN0YMgIG2MGQIyMHQsSUkaQGDoiwZCR0j/6SF6gl7xACi+QtC+HjUudNufzrT995/P57rNS+xi8Pz8u7l/eFBdXMWycJX14gX1Mzzn4vW1pu6n7+AbIW7KxAZYHyaPUQaISeOjSrAv/1K8OngJdSNRg7ugEPweQqhpPTprTUZROnGF9TKn+PznqS43409JrRqrFi2RXU8vQxtYVoWAgVTb1CZtYp54aeskmNqnNW8Q5C3XVQz0R+OIpYWYatfbQem6Kaj200WXdwgNphURluY+WutUjgd6pSeGjle5lLNChSgU6VqmvGbodYwWBfgS08rlyzfJ95V7JfZbfSH5feTYGKHwlz0IzGZhneRfkPfLs4GrnDfL+yrsv+0bAc2S/Cnid7JMBj5X9OeDtgX8h8Kew/9Ev78HvEWic5SIAAAAASUVORK5CYII='
};
dinamic_root_Dinamic_["setLocalImage"](Images);

dinamic_root_Dinamic_["registerView"]('CheckBox', CheckBox_CheckBox);
dinamic_root_Dinamic_["registerView"]('DCheckBox', CheckBox_CheckBox);

/* harmony default export */ var components_CheckBox = (CheckBox_CheckBox);
// CONCATENATED MODULE: ./src/components/TextInput.jsx
var TextInput_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var TextInput_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function TextInput_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TextInput_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TextInput_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TextInput_TextInput = function (_TextView) {
  TextInput_inherits(TextInput, _TextView);

  function TextInput(props) {
    TextInput_classCallCheck(this, TextInput);

    var _this = TextInput_possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props));

    _this.state = {
      _holderHelperName: '',
      _holderIndex: null
    };

    _this.blur = function () {
      var callback = _this.getEvents('textInput').onFinish;
      callback && callback.handler({ value: _this.$inputText.value });
    };

    _this.input = function () {
      var callback = _this.getEvents('textInput').onChange;
      callback && callback.handler({ value: _this.$inputText.value });
    };

    _this.focus = function () {
      var callback = _this.getEvents('textInput').onBegin;
      callback && callback.handler({ value: _this.$inputText.value });
    };

    _this.setStyles(TextInput_DefaultStyle, 'textInput');
    return _this;
  }

  TextInput_createClass(TextInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // input组件在tap时需要阻止冒泡
      utils_bindGestureEvent(this.$inputText, { tap: function tap() {} });
    }
  }, {
    key: 'text',
    value: function text(propValue) {
      this.setAttrs({ value: propValue }, 'textInput');
    }
  }, {
    key: 'textSize',
    value: function textSize(propValue) {
      this.setStyles({ fontSize: dinamic_root_Dinamic_["unitParser"](propValue) }, 'textInput');
    }
  }, {
    key: 'placeholderColor',
    value: function placeholderColor(propValue) {}
  }, {
    key: 'textColor',
    value: function textColor(propValue) {
      this.setStyles({
        color: dinamic_root_Dinamic_["colorParser"](propValue)
      }, 'textInput');
    }
  }, {
    key: 'keyboard',
    value: function keyboard(propValue) {
      this.setAttrs({ type: InputTypeMap[propValue] }, 'textInput');
    }
  }, {
    key: 'maxLength',
    value: function maxLength(propValue) {
      this.setAttrs({ maxNumber: propValue }, 'textInput');
    }
  }, {
    key: 'placeholder',
    value: function placeholder(propValue) {
      this.setAttrs({ placeholder: propValue }, 'textInput');
    }
  }, {
    key: 'textGravity',
    value: function textGravity(propValue) {
      this.setStyles({ textAlign: propValue }, 'textInput');
    }
  }, {
    key: 'onFinish',
    value: function onFinish(propValue) {
      this.setEvents({
        onFinish: propValue
      }, 'textInput');
    }
  }, {
    key: 'onChange',
    value: function onChange(propValue) {
      this.setEvents({
        onChange: propValue
      }, 'textInput');
    }
  }, {
    key: 'onBegin',
    value: function onBegin(propValue) {
      this.setEvents({
        onBegin: propValue
      }, 'textInput');
    }
  }, {
    key: 'renderView',
    value: function renderView() {
      var _this2 = this;

      var fontStyle = this.getStyles('font');
      var textInputStyle = this.getStyles('textInput');
      var mixStyle = TextInput_extends({}, fontStyle, textInputStyle);

      return dinamic_root_Dinamic_["h"]('input', TextInput_extends({
        ref: function ref($inputText) {
          return _this2.$inputText = $inputText;
        },
        onFocus: function onFocus(e) {
          return _this2.focus(e);
        },
        onInput: function onInput(e) {
          return _this2.input(e);
        },
        onBlur: function onBlur(e) {
          return _this2.blur(e);
        },
        style: mixStyle
      }, this.getAttrs('textInput'), {
        className: this.state._holderHelperName
      }));
    }
  }]);

  return TextInput;
}(components_TextView);

var InputTypeMap = {
  0: 'text',
  1: 'number',
  2: 'tel'
};
var TextInput_DefaultStyle = {
  width: '100%',
  height: '100%',
  outline: 'none',
  border: 'none',
  padding: 0,
  margin: 0,
  userSelect: 'auto'
};
TextInput_TextInput.defaultProps = {
  maxLength: -1,
  textSize: '12np',
  textGravity: 'left',
  keyboard: 0
};

dinamic_root_Dinamic_["registerView"]('TextInput', TextInput_TextInput);
dinamic_root_Dinamic_["registerView"]('DTextInput', TextInput_TextInput);

/* harmony default export */ var components_TextInput = (TextInput_TextInput);
// CONCATENATED MODULE: ./index.js
/* concated harmony reexport FrameLayout */__webpack_require__.d(__webpack_exports__, "FrameLayout", function() { return components_FrameLayout; });
/* concated harmony reexport LinearLayout */__webpack_require__.d(__webpack_exports__, "LinearLayout", function() { return components_LinearLayout; });
/* concated harmony reexport AdaptiveLinearLayout */__webpack_require__.d(__webpack_exports__, "AdaptiveLinearLayout", function() { return components_AdaptiveLinearLayout; });
/* concated harmony reexport ListLayout */__webpack_require__.d(__webpack_exports__, "ListLayout", function() { return components_ListLayout; });
/* concated harmony reexport FlexLayout */__webpack_require__.d(__webpack_exports__, "FlexLayout", function() { return components_FlexLayout; });
/* concated harmony reexport GridLayout */__webpack_require__.d(__webpack_exports__, "GridLayout", function() { return components_GridLayout; });
/* concated harmony reexport ScrollerLayout */__webpack_require__.d(__webpack_exports__, "ScrollerLayout", function() { return components_ScrollerLayout; });
/* concated harmony reexport View */__webpack_require__.d(__webpack_exports__, "View", function() { return components_View; });
/* concated harmony reexport TextView */__webpack_require__.d(__webpack_exports__, "TextView", function() { return components_TextView; });
/* concated harmony reexport ImageView */__webpack_require__.d(__webpack_exports__, "ImageView", function() { return components_ImageView; });
/* concated harmony reexport TImageView */__webpack_require__.d(__webpack_exports__, "TImageView", function() { return components_TImageView; });
/* concated harmony reexport HGifView */__webpack_require__.d(__webpack_exports__, "HGifView", function() { return components_HGifView; });
/* concated harmony reexport HVideoView */__webpack_require__.d(__webpack_exports__, "HVideoView", function() { return components_HVideoView; });
/* concated harmony reexport Switch */__webpack_require__.d(__webpack_exports__, "Switch", function() { return components_Switch; });
/* concated harmony reexport CheckBox */__webpack_require__.d(__webpack_exports__, "CheckBox", function() { return components_CheckBox; });
/* concated harmony reexport TextInput */__webpack_require__.d(__webpack_exports__, "TextInput", function() { return components_TextInput; });
/* concated harmony reexport bindGestureEvent */__webpack_require__.d(__webpack_exports__, "bindGestureEvent", function() { return utils_bindGestureEvent; });


// Layout








// View











// utils 

// 绑定手势事件


/***/ })
/******/ ]);
});